/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  ObjectId: { input: string; output: string; }
  PhoneNumber: { input: string; output: string; }
};

/** Describes a place using it's address */
export type AddressInputObjectType = {
  city: Scalars['String']['input'];
  country: CountryEnum;
  id: Scalars['String']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  streetNumber: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

/** Describes a place using it's address */
export type AddressObjectType = {
  __typename?: 'AddressObjectType';
  city: Scalars['String']['output'];
  country: CountryEnum;
  id: Scalars['String']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
  streetNumber: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

/** A list of all possible allergens */
export enum AllergensEnumType {
  /** Product contains celery */
  Celery = 'celery',
  /** Product contains crustaceans (a type of shellfish) */
  Crustaceans = 'crustaceans',
  /** Product contains eggs */
  Eggs = 'eggs',
  /** Product contains fish */
  Fish = 'fish',
  /** Product contains gluten */
  Gluten = 'gluten',
  /** Product contains lupin */
  Lupin = 'lupin',
  /** Product contains milk */
  Milk = 'milk',
  /** Product contains molluscs (a type of shellfish) */
  Molluscs = 'molluscs',
  /** Product contains mustard */
  Mustard = 'mustard',
  /** No allergens */
  None = 'none',
  /** Product contains nuts */
  Nuts = 'nuts',
  /** Product contains peanuts */
  Peanuts = 'peanuts',
  /** Product contains sesame seeds */
  Sesame = 'sesame',
  /** Product contains soya */
  Soya = 'soya',
  /** Product contains sulphur dioxide */
  SulphurDioxide = 'sulphurDioxide'
}

/** Describes an announcement */
export type AnnouncementInputObjectType = {
  content: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

/** Describes an announcement */
export type AnnouncementObjectType = {
  __typename?: 'AnnouncementObjectType';
  _id: Scalars['ObjectId']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Describes an api key */
export type ApiKeyObjectType = {
  __typename?: 'ApiKeyObjectType';
  _id: Scalars['ObjectId']['output'];
  createdAt: Scalars['DateTime']['output'];
  lastUsed: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type ApiKeyPaginatedResultObjectType = {
  __typename?: 'ApiKeyPaginatedResultObjectType';
  /** The amount of items in the response */
  count: Scalars['Int']['output'];
  /** Documents */
  docs: Array<ApiKeyObjectType>;
  /** The defined limit value */
  limit: Scalars['Int']['output'];
  /** The defined skip value */
  skip: Scalars['Int']['output'];
  /** The total amount of documents that match your query */
  total: Scalars['Int']['output'];
};

/** Type of account used for authentication */
export enum AuthTypeEnum {
  Api = 'api',
  User = 'user'
}

/** Information about a billing log. */
export type BillingLogObjectType = {
  __typename?: 'BillingLogObjectType';
  _id: Scalars['ObjectId']['output'];
  companyName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  organisation?: Maybe<OrganisationObjectType>;
  organisationId: Scalars['ObjectId']['output'];
  reference: Scalars['String']['output'];
  removeAt?: Maybe<Scalars['DateTime']['output']>;
  startDate: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vatNumber: Scalars['String']['output'];
};

/** A box is a a single box within a locker */
export type BoxObjectType = {
  __typename?: 'BoxObjectType';
  /** A sequential numeric id that is unique within the locker */
  id: Scalars['Int']['output'];
  language: Scalars['String']['output'];
  /** Last time this box was closed (from device state) */
  lastClosedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Last time this box was opened (from device state) */
  lastOpenedAt?: Maybe<Scalars['DateTime']['output']>;
  lockStatus: LockStatusEnum;
  pincode: Scalars['String']['output'];
  /** The reservation that should currently be or end up in the locker */
  reservation?: Maybe<ReservationObjectType>;
};

/** An object describing the box that has been reserved for a reservation */
export type BoxReservationInputObjectType = {
  /** The numeric id of the box this reservation occupies. */
  boxId: Scalars['Int']['input'];
  /** The internal id linking to the locker this reservation is created for. */
  lockerId: Scalars['ObjectId']['input'];
};

/** An object describing the box that has been reserved for a reservation */
export type BoxReservationObjectType = {
  __typename?: 'BoxReservationObjectType';
  /** The numeric id of the box this reservation occupies. */
  boxId: Scalars['Int']['output'];
  /** The locker this reservation is created for. */
  locker?: Maybe<LockerObjectType>;
  /** The internal id linking to the locker this reservation is created for. */
  lockerId: Scalars['ObjectId']['output'];
  /** Name of the locker, used as a public version of locker data. */
  lockerName?: Maybe<Scalars['String']['output']>;
};

/** Data Type for updating branding settings. */
export type BrandingSettingsInputObjectType = {
  brandColor: Scalars['String']['input'];
  /**
   * A google storage file key where the image is stored, for further processing
   * and linking (this has to be in the upload bucket of viresmo)
   */
  logoObjectKey?: InputMaybe<Scalars['String']['input']>;
};

/** Lock Status, open or closed */
export enum ConnectionStatusEnum {
  /** Device is offline */
  Offline = 'Offline',
  /** Device is online */
  Online = 'Online'
}

/** Country */
export enum CountryEnum {
  At = 'at',
  Be = 'be',
  De = 'de',
  Fr = 'fr',
  Lu = 'lu',
  Nl = 'nl'
}

/** Data needed to create a new customer. */
export type CreateCustomerInputObjectType = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * External id used for linking an internal customer to an external datasource,
   * usually this is the e-commerce or ERP system used by the company.
   */
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  language?: LanguageEnum;
  lastName: Scalars['String']['input'];
  phonenumbers?: InputMaybe<Array<Scalars['PhoneNumber']['input']>>;
  /** A dedicated pincode for the customer, so they can always pickup their order using the same pincode. */
  pincode?: InputMaybe<Scalars['String']['input']>;
  shopId: Scalars['ObjectId']['input'];
};

/** Data required to create/connect a locker */
export type CreateLockerInputObjectType = {
  boxCount?: Scalars['Int']['input'];
  name?: Scalars['String']['input'];
  serviceLocationId: Scalars['ObjectId']['input'];
  shopId: Scalars['ObjectId']['input'];
  temperatureType: LockerTemperatureTypeEnum;
};

/** Data required to create a reservation */
export type CreateReservationInputObjectType = {
  autoHideVendingAfterHours?: InputMaybe<Scalars['Int']['input']>;
  /** If true and the reservation has reach the configured time before pickup, we will automatically send a notification. */
  automaticallySendNotification?: Scalars['Boolean']['input'];
  /** Does this reservation contain food. */
  canUseMealVouchers?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The internal id of the customer this reservation belongs to. If none is
   * provided, contact information is required and we will automatically try to
   * link a customer using this information or create one if there is none.
   */
  customerId?: InputMaybe<Scalars['ObjectId']['input']>;
  /** The emails of the customer, defaults to the customer email if a customer id is provided. */
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  /** An optional external id to identify the order, mainly used for integrating with 3rd party platforms */
  externalOrderId?: InputMaybe<Scalars['String']['input']>;
  /** Information about the reservation, this is usually a description of the content. */
  extraInformation?: InputMaybe<Scalars['String']['input']>;
  /** The first name of the customer, defaults to the customer first name if a customer id is provided. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** A list of free vending product items */
  freeProducts?: Array<ProductCollectionItemInputObjectType>;
  /** Is reservation a vending reservation */
  isVendingReservation?: InputMaybe<Scalars['Boolean']['input']>;
  /** The preferred language of the customer */
  language?: LanguageEnum;
  /** The last name of the customer, defaults to the customer last name if a customer id is provided. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** If true and the reservation has been picked up this locker will remain reserved untill manually completed. */
  noAutoComplete?: Scalars['Boolean']['input'];
  /** The notifications that should be dispatched x amount of time before pickup. */
  notificationTypes?: Array<InputMaybe<NotificationTypeEnumType>>;
  /** An optional id pointing to a linked order */
  orderId?: InputMaybe<Scalars['ObjectId']['input']>;
  /** The phonenumbers of the customer, defaults to the customer phonenumber if a customer id is provided. */
  phonenumbers?: InputMaybe<Array<Scalars['PhoneNumber']['input']>>;
  /** The time the reservation is planned for pickup */
  pickupDateTime: Scalars['DateTime']['input'];
  /** A 4 character numeric pincode used for opening the locker at pickup */
  pincode?: InputMaybe<Scalars['String']['input']>;
  shopId: Scalars['ObjectId']['input'];
  /** Should customer still pay this reservation, this will send a pay link to the customer when box gets reserved. */
  shouldCustomerPay?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, this reservation will not have boxes assigned and will immediately have status RESERVED. */
  unboxed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional date until which the reservation is valid (houdbaar tot) in YYYY-MM-DD format */
  validUntil?: InputMaybe<Scalars['String']['input']>;
  /** A discount percentage to apply to the vending total price, ex 500 => 5% */
  vendingDiscount?: InputMaybe<Scalars['Int']['input']>;
  /** The vending discount intervals */
  vendingDiscountIntervals?: InputMaybe<Array<CreatevendingDiscountIntervalsInput>>;
  /** A list of vending product items */
  vendingProducts?: Array<ProductCollectionItemInputObjectType>;
  /** The total price of the reservation for vending purposes */
  vendingTotalPrice?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateUserInputObjectType = {
  email: Scalars['String']['input'];
  language?: InputMaybe<LanguageEnum>;
  name: Scalars['String']['input'];
  role: Scalars['Int']['input'];
};

export type CreatevendingDiscountIntervalsInput = {
  /** The discount percentage */
  discount: Scalars['Int']['input'];
  /** The hours after creation the discount should be applied */
  hoursAfterCreation: Scalars['Int']['input'];
};

/** Describes the customer with all information needed for reservations. */
export type CustomerObjectType = {
  __typename?: 'CustomerObjectType';
  /** Internal id used for linking with other data-types and to quickly find the customer in the database. */
  _id: Scalars['ObjectId']['output'];
  createdAt: Scalars['DateTime']['output'];
  emails: Array<Scalars['String']['output']>;
  /**
   * External id used for linking an internal customer to an external datasource,
   * usually this is the e-commerce or ERP system used by the company.
   */
  externalId?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  /** Numeric id used purely as a visual representation to the end-user */
  id: Scalars['Int']['output'];
  language: LanguageEnum;
  lastName: Scalars['String']['output'];
  phonenumbers: Array<Scalars['PhoneNumber']['output']>;
  /** A dedicated 5 character numeric pincode for the customer, so they can always pickup their order using the same pincode. */
  pincode?: Maybe<Scalars['String']['output']>;
  shop: ShopObjectType;
  shopId: Scalars['ObjectId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CustomerPaginatedResultObjectType = {
  __typename?: 'CustomerPaginatedResultObjectType';
  /** The amount of items in the response */
  count: Scalars['Int']['output'];
  /** Documents */
  docs: Array<CustomerObjectType>;
  /** The defined limit value */
  limit: Scalars['Int']['output'];
  /** The defined skip value */
  skip: Scalars['Int']['output'];
  /** The total amount of documents that match your query */
  total: Scalars['Int']['output'];
};

/** Sort the results based on the value of this object */
export type CustomerSortInputObjectType = {
  /** Sort based on the value: _id */
  _id?: InputMaybe<SortEnumType>;
  /** Sort based on the value: emails */
  emails?: InputMaybe<SortEnumType>;
  /** Sort based on the value: externalId */
  externalId?: InputMaybe<SortEnumType>;
  /** Sort based on the value: firstName */
  firstName?: InputMaybe<SortEnumType>;
  /** Sort based on the value: id */
  id?: InputMaybe<SortEnumType>;
  /** Sort based on the value: lastName */
  lastName?: InputMaybe<SortEnumType>;
  /** Sort based on the value: phonenumbers */
  phonenumbers?: InputMaybe<SortEnumType>;
  /** Sort based on the value: updatedAt */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A range used to filter based on timestamps. */
export type DateRangeInputObjectType = {
  /** Filtered objects should fall before this date */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Return items that fall after this date */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Return items that fall on or after this date */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Return items that fall before this date */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Return items that fall on or before this date */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filtered objects should fall after this date */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Filter dealers... */
export type DealerFilterInputObjectType = {
  resellerId?: InputMaybe<Scalars['ObjectId']['input']>;
};

/** Information required to create or update an dealer. */
export type DealerInputObjectType = {
  address: AddressInputObjectType;
  companyName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  phonenumber: Scalars['PhoneNumber']['input'];
  registrationNumber: Scalars['String']['input'];
  resellerId: Scalars['ObjectId']['input'];
  vatNumber: Scalars['String']['input'];
};

/** Information about a dealer. */
export type DealerObjectType = {
  __typename?: 'DealerObjectType';
  _id: Scalars['ObjectId']['output'];
  address: AddressObjectType;
  companyName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  /** External id used to identify a dealer, this id might get used for invoices and support */
  id: Scalars['Int']['output'];
  phonenumber: Scalars['PhoneNumber']['output'];
  registrationNumber: Scalars['String']['output'];
  reseller?: Maybe<ResellerObjectType>;
  resellerId: Scalars['ObjectId']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vatNumber: Scalars['String']['output'];
};

/** The firmware versions of a specific device */
export type DeviceFirmwareVersionsObjectType = {
  __typename?: 'DeviceFirmwareVersionsObjectType';
  /** Firmware version of the gateway */
  gateway: Scalars['Int']['output'];
  /** Firmware version of the keypad */
  keypad: Scalars['Int']['output'];
  /** Firmware version of the locks */
  lock: Scalars['Int']['output'];
};

export type DeviceLogFilterInputObjectType = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  lockerId?: InputMaybe<Scalars['ObjectId']['input']>;
  operation?: InputMaybe<DeviceLogOperationEnum>;
  serviceLocationId?: InputMaybe<Scalars['ObjectId']['input']>;
  severity?: InputMaybe<SeverityEnumType>;
  shopId?: InputMaybe<Scalars['ObjectId']['input']>;
  type?: InputMaybe<DeviceLogTypeEnum>;
};

/** This is a log originating from an mqtt device. */
export type DeviceLogObjectType = {
  __typename?: 'DeviceLogObjectType';
  _id: Scalars['ObjectId']['output'];
  createdAt: Scalars['DateTime']['output'];
  deviceId: Scalars['String']['output'];
  errorCode?: Maybe<Scalars['String']['output']>;
  locker?: Maybe<LockerObjectType>;
  lockerId?: Maybe<Scalars['ObjectId']['output']>;
  message: Scalars['String']['output'];
  operation: DeviceLogOperationEnum;
  removeAt?: Maybe<Scalars['DateTime']['output']>;
  serviceLocation?: Maybe<ServiceLocationObjectType>;
  serviceLocationId: Scalars['ObjectId']['output'];
  severity: SeverityEnumType;
  shop?: Maybe<ShopObjectType>;
  shopId: Scalars['ObjectId']['output'];
  temperature?: Maybe<Scalars['Float']['output']>;
  type: DeviceLogTypeEnum;
};

/** The operation executed on or by the device */
export enum DeviceLogOperationEnum {
  Error = 'Error',
  ForceUpdate = 'ForceUpdate',
  GatewayConfigUpdate = 'GatewayConfigUpdate',
  LatestVersion = 'LatestVersion',
  LockerState = 'LockerState',
  LockerUpdate = 'LockerUpdate',
  OpenLocks = 'OpenLocks',
  RequestLatestVersion = 'RequestLatestVersion',
  RequestLockerConfig = 'RequestLockerConfig',
  State = 'State',
  TerminalAction = 'TerminalAction',
  Unknown = 'Unknown'
}

export type DeviceLogPaginatedResultObjectType = {
  __typename?: 'DeviceLogPaginatedResultObjectType';
  /** The amount of items in the response */
  count: Scalars['Int']['output'];
  /** Documents */
  docs: Array<DeviceLogObjectType>;
  /** The defined limit value */
  limit: Scalars['Int']['output'];
  /** The defined skip value */
  skip: Scalars['Int']['output'];
  /** The total amount of documents that match your query */
  total: Scalars['Int']['output'];
};

/** Sort the results based on the value of this object */
export type DeviceLogSortInputObjectType = {
  /** Sort based on the value: _id */
  _id?: InputMaybe<SortEnumType>;
  /** Sort based on the value: deviceId */
  deviceId?: InputMaybe<SortEnumType>;
  /** Sort based on the value: errorCode */
  errorCode?: InputMaybe<SortEnumType>;
  /** Sort based on the value: operation */
  operation?: InputMaybe<SortEnumType>;
  /** Sort based on the value: severity */
  severity?: InputMaybe<SortEnumType>;
  /** Sort based on the value: temperature */
  temperature?: InputMaybe<SortEnumType>;
  /** Sort based on the value: type */
  type?: InputMaybe<SortEnumType>;
};

/** The type of device log */
export enum DeviceLogTypeEnum {
  Command = 'Command',
  Event = 'Event'
}

/** Type of account used for authentication */
export enum FirmwareTypeEnum {
  GatewayV1 = 'GatewayV1',
  LockControllerV1 = 'LockControllerV1',
  PinpadControllerV1 = 'PinpadControllerV1'
}

/** Describes a Firmware Version. */
export type FirmwareVersionObjectType = {
  __typename?: 'FirmwareVersionObjectType';
  /** Internal id used for linking with other data-types and to quickly find the firmware version in the database. */
  _id: Scalars['ObjectId']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Type of firmware this object describes. */
  type: FirmwareTypeEnum;
  updatedAt: Scalars['DateTime']['output'];
  /** Version number of the firmware */
  version: Scalars['Int']['output'];
};

export type FirmwareVersionPaginatedResultObjectType = {
  __typename?: 'FirmwareVersionPaginatedResultObjectType';
  /** The amount of items in the response */
  count: Scalars['Int']['output'];
  /** Documents */
  docs: Array<FirmwareVersionObjectType>;
  /** The defined limit value */
  limit: Scalars['Int']['output'];
  /** The defined skip value */
  skip: Scalars['Int']['output'];
  /** The total amount of documents that match your query */
  total: Scalars['Int']['output'];
};

/** Sort the results based on the value of this object */
export type FirmwareVersionSortInputObjectType = {
  /** Sort based on the value: _id */
  _id?: InputMaybe<SortEnumType>;
  /** Sort based on the value: type */
  type?: InputMaybe<SortEnumType>;
  /** Sort based on the value: updatedAt */
  updatedAt?: InputMaybe<SortEnumType>;
  /** Sort based on the value: version */
  version?: InputMaybe<SortEnumType>;
};

/** A range used to filter on a numeric value (Float). */
export type FloatRangeInputObjectType = {
  /** Return items that are greater than the specified value */
  gt?: InputMaybe<Scalars['Float']['input']>;
  /** Return items that are greater than or equal to the specified value */
  gte?: InputMaybe<Scalars['Float']['input']>;
  /** Return items that are lesser than the specified value */
  lt?: InputMaybe<Scalars['Float']['input']>;
  /** Return items that are lesser than or equal to the specified value */
  lte?: InputMaybe<Scalars['Float']['input']>;
};

/** A range used to filter on a numeric value (Integer). */
export type IntRangeInputObjectType = {
  /** Return items that are greater than the specified value */
  gt?: InputMaybe<Scalars['Int']['input']>;
  /** Return items that are greater than or equal to the specified value */
  gte?: InputMaybe<Scalars['Int']['input']>;
  /** Return items that are lesser than the specified value */
  lt?: InputMaybe<Scalars['Int']['input']>;
  /** Return items that are lesser than or equal to the specified value */
  lte?: InputMaybe<Scalars['Int']['input']>;
};

/** Kiosk Bancontact/Payconiq QR shortcut: default (code default), qr (prefer QR), or gateway (hosted page) */
export enum KioskPaymentQrModeEnumType {
  /** Follow the code default (currently QR shortcut enabled) */
  Default = 'Default',
  /** Always use the normal gateway hosted checkout page */
  Gateway = 'Gateway',
  /** Prefer showing Bancontact/Payconiq QR when the gateway supports it */
  Qr = 'Qr'
}

/** Language */
export enum LanguageEnum {
  De = 'de',
  En = 'en',
  Fr = 'fr',
  Nl = 'nl'
}

/** An Object that represent a string in a certain language. */
export type LocalisedStringInputObjectType = {
  /** The language of the string. */
  language: LanguageEnum;
  /** The value of the string. */
  value: Scalars['String']['input'];
};

/** An Object that represent a string in a certain language. */
export type LocalisedStringObjectType = {
  __typename?: 'LocalisedStringObjectType';
  /** The language of the string. */
  language: LanguageEnum;
  /** The value of the string. */
  value: Scalars['String']['output'];
};

/** Lock Status, open or closed */
export enum LockStatusEnum {
  /** Lock is closed */
  Closed = 'closed',
  /** Lock is open */
  Open = 'open'
}

/** A collection of pickup boxes, with additional metadata, future reservations and connectivity details */
export type LockerObjectType = {
  __typename?: 'LockerObjectType';
  _id: Scalars['ObjectId']['output'];
  /** A list of reservations, currently in the locker. */
  activeReservations: Array<Maybe<ReservationObjectType>>;
  /**
   * Amount of boxes in the locker
   * @deprecated You can use boxes.length instead
   */
  boxCount: Scalars['Int']['output'];
  /** List of the boxes that are part of the locker */
  boxes?: Maybe<Array<Maybe<BoxObjectType>>>;
  createdAt: Scalars['DateTime']['output'];
  /** Whether this locker is in lockdown or not, happens whenever something is broken or temperature is too low/high */
  isInLockdown: Scalars['Boolean']['output'];
  /** Indicates whether this locker is a test locker, test lockers do not have an attached device id. */
  isTestLocker: Scalars['Boolean']['output'];
  /** Last time we received a state update for this locker */
  lastStateUpdateReceivedAt?: Maybe<Scalars['DateTime']['output']>;
  lockerId: Scalars['Int']['output'];
  /** Last time the main door was closed (from device state) */
  mainDoorLastClosedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Last time the main door was opened (from device state) */
  mainDoorLastOpenedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The status of the main door */
  mainDoorStatus: LockStatusEnum;
  /** Lockers Name */
  name: Scalars['String']['output'];
  /** The service location this locker is located. */
  serviceLocation?: Maybe<ServiceLocationObjectType>;
  /** An internal id linking to the service location this locker is located. */
  serviceLocationId: Scalars['ObjectId']['output'];
  shop: ShopObjectType;
  shopId: Scalars['ObjectId']['output'];
  /** Last measured temperature */
  temperature?: Maybe<LockerTemperatureObjectType>;
  temperatureType: LockerTemperatureTypeEnum;
  updatedAt: Scalars['DateTime']['output'];
};


/** A collection of pickup boxes, with additional metadata, future reservations and connectivity details */
export type LockerObjectTypeBoxesArgs = {
  cooldown?: InputMaybe<Scalars['Int']['input']>;
};

export type LockerPaginatedResultObjectType = {
  __typename?: 'LockerPaginatedResultObjectType';
  /** The amount of items in the response */
  count: Scalars['Int']['output'];
  /** Documents */
  docs: Array<LockerObjectType>;
  /** The defined limit value */
  limit: Scalars['Int']['output'];
  /** The defined skip value */
  skip: Scalars['Int']['output'];
  /** The total amount of documents that match your query */
  total: Scalars['Int']['output'];
};

/** Aggregated temperature metrics for a single calendar day */
export type LockerTemperatureDayObjectType = {
  __typename?: 'LockerTemperatureDayObjectType';
  /** Time-weighted average temperature for the day (hold-forward between samples), null if no data */
  average?: Maybe<Scalars['Float']['output']>;
  /** Calendar day in YYYY-MM-DD (in the requested time zone) */
  date: Scalars['String']['output'];
  /** Number of long above-threshold episodes that touch this day */
  longEpisodes: Scalars['Int']['output'];
  /** Maximum held temperature during the day, null if no data */
  max?: Maybe<Scalars['Float']['output']>;
  /** Minimum held temperature during the day, null if no data */
  min?: Maybe<Scalars['Float']['output']>;
  /** Minutes the held temperature was above the threshold */
  minutesAboveThreshold: Scalars['Int']['output'];
};

/** A continuous period where temperature stayed above the threshold */
export type LockerTemperatureEpisodeObjectType = {
  __typename?: 'LockerTemperatureEpisodeObjectType';
  durationMinutes: Scalars['Float']['output'];
  endedAt: Scalars['DateTime']['output'];
  maxTemperature: Scalars['Float']['output'];
  startedAt: Scalars['DateTime']['output'];
};

/** A temperature measure of a locker */
export type LockerTemperatureObjectType = {
  __typename?: 'LockerTemperatureObjectType';
  _id: Scalars['ObjectId']['output'];
  createdAt: Scalars['DateTime']['output'];
  lockerId: Scalars['ObjectId']['output'];
  removeAt: Scalars['DateTime']['output'];
  /** Temperature at this point in time */
  temperature: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Daily temperature-check metrics for a locker over a date range */
export type LockerTemperatureSummaryObjectType = {
  __typename?: 'LockerTemperatureSummaryObjectType';
  days: Array<LockerTemperatureDayObjectType>;
  episodes: Array<LockerTemperatureEpisodeObjectType>;
  longEpisodeCount: Scalars['Int']['output'];
  rangeEnd: Scalars['DateTime']['output'];
  rangeStart: Scalars['DateTime']['output'];
  /** Number of temperature samples used (including hold-forward) */
  sampleCount: Scalars['Int']['output'];
  totalMinutesAboveThreshold: Scalars['Int']['output'];
  /** True when the sample set hit the server-side safety cap */
  truncated: Scalars['Boolean']['output'];
};

/** Locker type, defines temperature of locker */
export enum LockerTemperatureTypeEnum {
  /** Locker keeps warm temperatures (60-80°C) */
  Heated = 'Heated',
  /** Locker does not do any temperature control at all */
  NotCooled = 'NotCooled',
  /** Locker keeps refrigerator temperatures (3-6°C) */
  Refrigerated = 'Refrigerated',
  /** Locker keeps room temperature (12-25°C) */
  RoomTemperature = 'RoomTemperature'
}

export type LogFilterInputObjectType = {
  customerId?: InputMaybe<Scalars['ObjectId']['input']>;
  lockerId?: InputMaybe<Scalars['ObjectId']['input']>;
  operation?: InputMaybe<LogOperationEnum>;
  orderId?: InputMaybe<Scalars['ObjectId']['input']>;
  overwriteCodeId?: InputMaybe<Scalars['ObjectId']['input']>;
  productId?: InputMaybe<Scalars['ObjectId']['input']>;
  reservationId?: InputMaybe<Scalars['ObjectId']['input']>;
  serviceLocationId?: InputMaybe<Scalars['ObjectId']['input']>;
  severity?: InputMaybe<SeverityEnumType>;
  shopId?: InputMaybe<Scalars['ObjectId']['input']>;
  templateId?: InputMaybe<Scalars['ObjectId']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Audit log, returns all mutations and interactions with the platform by any user or api. */
export type LogItemObjectType = {
  __typename?: 'LogItemObjectType';
  _id: Scalars['ObjectId']['output'];
  apiKeyId?: Maybe<Scalars['ObjectId']['output']>;
  authType?: Maybe<AuthTypeEnum>;
  authenticatedApi?: Maybe<ApiKeyObjectType>;
  createdAt: Scalars['DateTime']['output'];
  customerId?: Maybe<Scalars['ObjectId']['output']>;
  description: Scalars['String']['output'];
  lockerId?: Maybe<Scalars['ObjectId']['output']>;
  operation: LogOperationEnum;
  orderId?: Maybe<Scalars['ObjectId']['output']>;
  overwriteCodeId?: Maybe<Scalars['ObjectId']['output']>;
  productId?: Maybe<Scalars['ObjectId']['output']>;
  raw: Scalars['String']['output'];
  removeAt?: Maybe<Scalars['DateTime']['output']>;
  reservationId?: Maybe<Scalars['ObjectId']['output']>;
  serviceLocationId?: Maybe<Scalars['ObjectId']['output']>;
  severity: SeverityEnumType;
  shopId?: Maybe<Scalars['ObjectId']['output']>;
  temperature?: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
  uid?: Maybe<Scalars['ObjectId']['output']>;
  user?: Maybe<UserObjectType>;
};

/** The kind of operation executed to result in the given log */
export enum LogOperationEnum {
  Created = 'Created',
  Deleted = 'Deleted',
  Error = 'Error',
  Opened = 'Opened',
  Received = 'Received',
  Sent = 'Sent',
  Updated = 'Updated'
}

export type LogPaginatedResultObjectType = {
  __typename?: 'LogPaginatedResultObjectType';
  /** The amount of items in the response */
  count: Scalars['Int']['output'];
  /** Documents */
  docs: Array<LogItemObjectType>;
  /** The defined limit value */
  limit: Scalars['Int']['output'];
  /** The defined skip value */
  skip: Scalars['Int']['output'];
  /** The total amount of documents that match your query */
  total: Scalars['Int']['output'];
};

/** Sort the audit logs */
export type LogSortInputObjectType = {
  _id?: InputMaybe<SortEnumType>;
  authType?: InputMaybe<SortEnumType>;
  operation?: InputMaybe<SortEnumType>;
  severity?: InputMaybe<SortEnumType>;
  temperature?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

/** The status of a website profile on Mollie. */
export type MollieConnectProfileObjectType = {
  __typename?: 'MollieConnectProfileObjectType';
  id: Scalars['String']['output'];
  isVerified: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** The status of your connection with Mollie. */
export type MollieConnectStatusObjectType = {
  __typename?: 'MollieConnectStatusObjectType';
  _id: Scalars['ObjectId']['output'];
  canReceivePayments: Scalars['Boolean']['output'];
  lastStatusCheckAt?: Maybe<Scalars['DateTime']['output']>;
  mollieOrganizationName?: Maybe<Scalars['String']['output']>;
  organisationId: Scalars['ObjectId']['output'];
  profile?: Maybe<MollieConnectProfileObjectType>;
  testmode: Scalars['Boolean']['output'];
};

/** Summary of a Mollie payment linked to an order, for troubleshooting. */
export type MolliePaymentSummaryObjectType = {
  __typename?: 'MolliePaymentSummaryObjectType';
  /** Customer checkout URL, if still available */
  checkoutUrl?: Maybe<Scalars['String']['output']>;
  /** Direct link to this payment in the Mollie Dashboard */
  dashboardUrl?: Maybe<Scalars['String']['output']>;
  /** Mollie payment id (tr_…) */
  id: Scalars['String']['output'];
  /** Whether Mollie currently allows cancelling this payment */
  isCancelable?: Maybe<Scalars['Boolean']['output']>;
  /** Payment method reported by Mollie (e.g. ideal, bancontact) */
  method?: Maybe<Scalars['String']['output']>;
  /** live or test */
  mode?: Maybe<Scalars['String']['output']>;
  /** Current Mollie payment status, if fetched live */
  status?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Mutation to add a user to the current organisation */
  addUserToOrganisation?: Maybe<UserObjectType>;
  /** Cancel an order */
  cancelOrder?: Maybe<OrderObjectType>;
  /** Used to cancel an order using its shortToken. */
  cancelOrderUsingToken?: Maybe<OrderObjectType>;
  /** Changes the lockers lockdown status */
  changeLockerLockdownStatus?: Maybe<LockerObjectType>;
  claimPrintHub: PrintHubObjectType;
  /** Used to remove all notifications. */
  clearNotifications?: Maybe<Scalars['Int']['output']>;
  /** Update Mollie connect credentials. */
  connectMollie?: Maybe<MollieConnectStatusObjectType>;
  /** Complete Stripe Connect OAuth for an organisation. */
  connectStripe?: Maybe<StripeConnectStatusObjectType>;
  /** Used to create an announcement */
  createAnnouncement?: Maybe<AnnouncementObjectType>;
  /** This is used to create a new API key, this can only be used by a real user in the platforms dashboard */
  createApiKey?: Maybe<ApiKeyObjectType>;
  /** Used to create a new customer, which can be used to link to reservations and orders */
  createCustomer?: Maybe<CustomerObjectType>;
  /** Used to create a dealer. */
  createDealer?: Maybe<DealerObjectType>;
  /** Used to add a locker to the platform. */
  createLocker?: Maybe<LockerObjectType>;
  /** Used to create an organisation. */
  createOrganisation?: Maybe<OrganisationObjectType>;
  /** Used to create a new overwrite code */
  createOverwriteCode?: Maybe<OverwriteCodeObjectType>;
  createPrintHubTestPrint: Scalars['Boolean']['output'];
  /** Used to create a new product */
  createProduct?: Maybe<ProductObjectType>;
  /** Used to create a reseller. */
  createReseller?: Maybe<ResellerObjectType>;
  /** Used for creating a reservation */
  createReservation?: Maybe<ReservationObjectType>;
  /** Used to create a service location */
  createServiceLocation?: Maybe<ServiceLocationObjectType>;
  /** Used to create a shop */
  createShop?: Maybe<ShopObjectType>;
  /** Used to create a subscription item */
  createUploadRequest: UploadRequestTokenObjectType;
  createWoytiOrder?: Maybe<OrderObjectType>;
  /** Used to delete all products of a shop. */
  deleteAllProducts?: Maybe<Scalars['Int']['output']>;
  /** Used to delete an announcement */
  deleteAnnouncement?: Maybe<AnnouncementObjectType>;
  /** This is used to create a new API key, this can only be used by a real user in the platforms dashboard */
  deleteApiKey?: Maybe<ApiKeyObjectType>;
  /** Used to delete a customer. */
  deleteCustomer?: Maybe<CustomerObjectType>;
  /** Used to delete a dealer. */
  deleteDealer?: Maybe<DealerObjectType>;
  /** Used to delete a locker. */
  deleteLocker?: Maybe<LockerObjectType>;
  /** Used to delete certain notifications using the ids. */
  deleteNotifications?: Maybe<Scalars['Int']['output']>;
  /** Used to delete an organisation. */
  deleteOrganisation?: Maybe<OrganisationObjectType>;
  /** Used to delete an overwrite code. */
  deleteOverwriteCode?: Maybe<OverwriteCodeObjectType>;
  /** Used to delete a product. */
  deleteProduct?: Maybe<ProductObjectType>;
  /** Used to delete a reseller. */
  deleteReseller?: Maybe<ResellerObjectType>;
  /** Used to delete a service location. */
  deleteServiceLocation?: Maybe<ServiceLocationObjectType>;
  /** Used to delete a shop */
  deleteShop?: Maybe<ShopObjectType>;
  /** Disconnect Mollie organisation. */
  disconnectMollie?: Maybe<MollieConnectStatusObjectType>;
  /** Disconnect Stripe from an organisation. */
  disconnectStripe?: Maybe<StripeConnectStatusObjectType>;
  dispatchReservationNotification?: Maybe<ReservationObjectType>;
  dispatchWoytiNotifications?: Maybe<Scalars['Boolean']['output']>;
  /** Create payment checkout for an order using its shortToken. When preferQr is true and the org allows it, request a Bancontact/Payconiq QR if the gateway supports it. */
  ensureOrderCheckoutUsingToken?: Maybe<OrderObjectType>;
  /** Used to force a firmware update. */
  forceFirmwareUpdate?: Maybe<Scalars['Boolean']['output']>;
  /** Mutation to confirm you have read the last announcements */
  hideAnnouncementForCurrentUser?: Maybe<Scalars['Boolean']['output']>;
  /** Used to import new customers, this also ensures no customers get duplicated */
  importCustomers: Array<Maybe<CustomerObjectType>>;
  /** Used to import products */
  importProducts: Array<Maybe<ProductObjectType>>;
  /** Used to invite a user to a dealer. */
  inviteUserToDealer?: Maybe<UserObjectType>;
  /** Used to invite a user to a reseller. */
  inviteUserToReseller?: Maybe<UserObjectType>;
  /** Request an link to connect Mollie. */
  mollieConnectLink?: Maybe<Scalars['String']['output']>;
  /** Opens a box in a locker, returns true if locker is active and box exists */
  openLockerBoxes?: Maybe<LockerObjectType>;
  /** Used to open the lockers of a specific order */
  openLockersByOrderIdAndToken?: Maybe<Scalars['Boolean']['output']>;
  /** Used to open the lockers of a specific reservation */
  openLockersByReservationIdAndToken?: Maybe<Scalars['Boolean']['output']>;
  /** Refund an order */
  refundOrder: Scalars['Boolean']['output'];
  /** Used to remove a user from a dealer. */
  removeUserFromDealer?: Maybe<Scalars['Boolean']['output']>;
  /** Mutation to remove a user from the current organisation */
  removeUserFromOrganisation?: Maybe<Scalars['Boolean']['output']>;
  /** Used to remove a user from a reseller. */
  removeUserFromReseller?: Maybe<Scalars['Boolean']['output']>;
  /** Settle a sandbox checkout from the shop order page: paid, expired, or canceled. */
  resolveSandboxPaymentUsingToken?: Maybe<OrderObjectType>;
  /** Choose how kiosk checkouts handle Bancontact/Payconiq QR vs gateway page. */
  setKioskPaymentQrMode?: Maybe<OrganisationObjectType>;
  /** Enable/Disable testmode for testing Mollie payments. */
  setMollieTestmode?: Maybe<MollieConnectStatusObjectType>;
  /** Choose which payment gateway is used for new checkouts. */
  setPaymentGateway?: Maybe<OrganisationObjectType>;
  /** Change Mollie profile. */
  setSelectedMollieProfile?: Maybe<MollieConnectStatusObjectType>;
  /** Used to set the stable firmware version */
  setStableFirmwareVersion?: Maybe<Scalars['Boolean']['output']>;
  /** OAuth URL to connect the organisation Stripe account. */
  stripeConnectLink?: Maybe<Scalars['String']['output']>;
  unclaimPrintHub?: Maybe<PrintHubObjectType>;
  /** Used to update an announcement */
  updateAnnouncement?: Maybe<AnnouncementObjectType>;
  /** Used to update branding settings. */
  updateBrandingSettings?: Maybe<OrganisationObjectType>;
  /** Used to update an existing customer */
  updateCustomer?: Maybe<CustomerObjectType>;
  /** Used to update a dealer. */
  updateDealer?: Maybe<DealerObjectType>;
  /** Used to update a lockers data. */
  updateLocker?: Maybe<LockerObjectType>;
  /** Used to update an orders contact details */
  updateOrderContactDetails?: Maybe<OrderObjectType>;
  /** Used to update an organisation. */
  updateOrganisation?: Maybe<OrganisationObjectType>;
  /** Used to update organisation email settings. */
  updateOrganisationEmailSettings?: Maybe<OrganisationEmailSettingsObjectType>;
  /** Used to update organisation settings. */
  updateOrganisationJoynSettings?: Maybe<OrganisationObjectType>;
  /** Used to update organisation quality guard settings. */
  updateOrganisationQualityGuardSettings?: Maybe<OrganisationObjectType>;
  /** Used to update organisation settings. */
  updateOrganisationSettings?: Maybe<OrganisationObjectType>;
  /** Used to update an existing overwrite code */
  updateOverwriteCode?: Maybe<OverwriteCodeObjectType>;
  /** Mutation used to update your password. */
  updatePassword?: Maybe<UserObjectType>;
  updatePrintHubClaim: PrintHubObjectType;
  updatePrintHubSettings: PrintHubObjectType;
  /** Used to update an existing product */
  updateProduct?: Maybe<ProductObjectType>;
  /** Used to create a new product */
  updateQuotaLimit?: Maybe<QuotaUsageObjectType>;
  /** Used to update a reseller. */
  updateReseller?: Maybe<ResellerObjectType>;
  /** Used for updating a reservation */
  updateReservation?: Maybe<ReservationObjectType>;
  /** Used for updating the status of a reservation */
  updateReservationStatus?: Maybe<Scalars['Boolean']['output']>;
  /** Used to update a service location */
  updateServiceLocation?: Maybe<ServiceLocationObjectType>;
  /** Used to update multiple service locations from the admin panel */
  updateServiceLocations?: Maybe<Scalars['Boolean']['output']>;
  /** Used to update shop settings */
  updateShop?: Maybe<ShopObjectType>;
  /** Mutation used to update your user preferences. */
  updateUserPreferences?: Maybe<UserObjectType>;
  /** Mutation used for updating a user's role within the current organisation. */
  updateUserRole?: Maybe<UserObjectType>;
  /** Used to create a new product */
  upsertReservationSettings?: Maybe<ReservationSettingsObjectType>;
  /** Upsert WooCommerce integration. */
  upsertWooCommerceIntegration?: Maybe<WooCommerceIntegrationObjectType>;
  upsertWoytiPreferences?: Maybe<WoytiPreferences>;
};


export type MutationAddUserToOrganisationArgs = {
  data: CreateUserInputObjectType;
};


export type MutationCancelOrderArgs = {
  id: Scalars['ObjectId']['input'];
};


export type MutationCancelOrderUsingTokenArgs = {
  id: Scalars['ObjectId']['input'];
  token: Scalars['String']['input'];
};


export type MutationChangeLockerLockdownStatusArgs = {
  lockerId: Scalars['ObjectId']['input'];
  newInLockdown?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationClaimPrintHubArgs = {
  claimToken: Scalars['String']['input'];
  printSettings?: InputMaybe<PrintHubClaimPrintSettingsInputObjectType>;
  printerName: Scalars['String']['input'];
  shopId: Scalars['ObjectId']['input'];
};


export type MutationConnectMollieArgs = {
  code: Scalars['String']['input'];
  state: Scalars['String']['input'];
};


export type MutationConnectStripeArgs = {
  code: Scalars['String']['input'];
  state: Scalars['String']['input'];
};


export type MutationCreateAnnouncementArgs = {
  data: AnnouncementInputObjectType;
};


export type MutationCreateApiKeyArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateCustomerArgs = {
  data: CreateCustomerInputObjectType;
};


export type MutationCreateDealerArgs = {
  data: DealerInputObjectType;
};


export type MutationCreateLockerArgs = {
  data: CreateLockerInputObjectType;
};


export type MutationCreateOrganisationArgs = {
  data: OrganisationInputObjectType;
};


export type MutationCreateOverwriteCodeArgs = {
  data: OverwriteCodeInputObjectType;
};


export type MutationCreatePrintHubTestPrintArgs = {
  shopId: Scalars['ObjectId']['input'];
};


export type MutationCreateProductArgs = {
  data: ProductInputObjectType;
};


export type MutationCreateResellerArgs = {
  data: ResellerInputObjectType;
};


export type MutationCreateReservationArgs = {
  data: CreateReservationInputObjectType;
};


export type MutationCreateServiceLocationArgs = {
  data: ServiceLocationInputObjectType;
};


export type MutationCreateShopArgs = {
  data: ShopInputObjectType;
};


export type MutationCreateUploadRequestArgs = {
  filename: Scalars['String']['input'];
};


export type MutationCreateWoytiOrderArgs = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  items: Array<Scalars['ObjectId']['input']>;
  language: LanguageEnum;
  lastName: Scalars['String']['input'];
  shopId: Scalars['ObjectId']['input'];
};


export type MutationDeleteAllProductsArgs = {
  organisationId: Scalars['ObjectId']['input'];
};


export type MutationDeleteAnnouncementArgs = {
  id: Scalars['ObjectId']['input'];
};


export type MutationDeleteApiKeyArgs = {
  id: Scalars['ObjectId']['input'];
};


export type MutationDeleteCustomerArgs = {
  id: Scalars['ObjectId']['input'];
};


export type MutationDeleteDealerArgs = {
  id: Scalars['ObjectId']['input'];
};


export type MutationDeleteLockerArgs = {
  id: Scalars['ObjectId']['input'];
};


export type MutationDeleteNotificationsArgs = {
  ids: Array<Scalars['ObjectId']['input']>;
};


export type MutationDeleteOrganisationArgs = {
  id: Scalars['ObjectId']['input'];
};


export type MutationDeleteOverwriteCodeArgs = {
  id: Scalars['ObjectId']['input'];
};


export type MutationDeleteProductArgs = {
  id: Scalars['ObjectId']['input'];
};


export type MutationDeleteResellerArgs = {
  id: Scalars['ObjectId']['input'];
};


export type MutationDeleteServiceLocationArgs = {
  id: Scalars['ObjectId']['input'];
};


export type MutationDeleteShopArgs = {
  id: Scalars['ObjectId']['input'];
};


export type MutationDispatchReservationNotificationArgs = {
  id: Scalars['ObjectId']['input'];
};


export type MutationDispatchWoytiNotificationsArgs = {
  shopId: Scalars['ObjectId']['input'];
};


export type MutationEnsureOrderCheckoutUsingTokenArgs = {
  dropUnavailable?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ObjectId']['input'];
  preferQr?: InputMaybe<Scalars['Boolean']['input']>;
  retry?: InputMaybe<Scalars['Boolean']['input']>;
  token: Scalars['String']['input'];
};


export type MutationForceFirmwareUpdateArgs = {
  id: Scalars['ObjectId']['input'];
};


export type MutationImportCustomersArgs = {
  customers: Array<CreateCustomerInputObjectType>;
};


export type MutationImportProductsArgs = {
  products: Array<ProductInputObjectType>;
};


export type MutationInviteUserToDealerArgs = {
  dealerId: Scalars['ObjectId']['input'];
  email: Scalars['String']['input'];
  language?: InputMaybe<LanguageEnum>;
  name: Scalars['String']['input'];
};


export type MutationInviteUserToResellerArgs = {
  email: Scalars['String']['input'];
  language?: InputMaybe<LanguageEnum>;
  name: Scalars['String']['input'];
  resellerId: Scalars['ObjectId']['input'];
};


export type MutationOpenLockerBoxesArgs = {
  boxIds: Array<Scalars['Int']['input']>;
  lockerId: Scalars['ObjectId']['input'];
  openMainDoor?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationOpenLockersByOrderIdAndTokenArgs = {
  id: Scalars['ObjectId']['input'];
  token: Scalars['String']['input'];
};


export type MutationOpenLockersByReservationIdAndTokenArgs = {
  id: Scalars['ObjectId']['input'];
  token: Scalars['String']['input'];
};


export type MutationRefundOrderArgs = {
  amount: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  id: Scalars['ObjectId']['input'];
};


export type MutationRemoveUserFromDealerArgs = {
  dealerId: Scalars['ObjectId']['input'];
  userId: Scalars['ObjectId']['input'];
};


export type MutationRemoveUserFromOrganisationArgs = {
  userId: Scalars['ObjectId']['input'];
};


export type MutationRemoveUserFromResellerArgs = {
  resellerId: Scalars['ObjectId']['input'];
  userId: Scalars['ObjectId']['input'];
};


export type MutationResolveSandboxPaymentUsingTokenArgs = {
  id: Scalars['ObjectId']['input'];
  status: OrderStatusEnumType;
  token: Scalars['String']['input'];
};


export type MutationSetKioskPaymentQrModeArgs = {
  kioskPaymentQrMode: KioskPaymentQrModeEnumType;
};


export type MutationSetMollieTestmodeArgs = {
  testmode: Scalars['Boolean']['input'];
};


export type MutationSetPaymentGatewayArgs = {
  paymentGateway: PaymentGatewayEnumType;
};


export type MutationSetSelectedMollieProfileArgs = {
  profileId: Scalars['String']['input'];
};


export type MutationSetStableFirmwareVersionArgs = {
  firmwareId: Scalars['ObjectId']['input'];
};


export type MutationUnclaimPrintHubArgs = {
  shopId: Scalars['ObjectId']['input'];
};


export type MutationUpdateAnnouncementArgs = {
  data: AnnouncementInputObjectType;
  id: Scalars['ObjectId']['input'];
};


export type MutationUpdateBrandingSettingsArgs = {
  data: BrandingSettingsInputObjectType;
};


export type MutationUpdateCustomerArgs = {
  data: UpdateCustomerInputObjectType;
  id: Scalars['ObjectId']['input'];
};


export type MutationUpdateDealerArgs = {
  data: DealerInputObjectType;
  id: Scalars['ObjectId']['input'];
};


export type MutationUpdateLockerArgs = {
  data: UpdateLockerInputObjectType;
  id: Scalars['ObjectId']['input'];
};


export type MutationUpdateOrderContactDetailsArgs = {
  data: UpdateOrderInputObjectType;
  id: Scalars['ObjectId']['input'];
};


export type MutationUpdateOrganisationArgs = {
  data: OrganisationInputObjectType;
  id: Scalars['ObjectId']['input'];
};


export type MutationUpdateOrganisationEmailSettingsArgs = {
  data: OrganisationEmailSettingsInputObjectType;
};


export type MutationUpdateOrganisationJoynSettingsArgs = {
  data: OrganisationJoynSettingsInputObjectType;
};


export type MutationUpdateOrganisationQualityGuardSettingsArgs = {
  data: OrganisationQualityGuardSettingsInputObjectType;
};


export type MutationUpdateOrganisationSettingsArgs = {
  data: OrganisationSettingsInputObjectType;
};


export type MutationUpdateOverwriteCodeArgs = {
  data: OverwriteCodeInputObjectType;
  id: Scalars['ObjectId']['input'];
};


export type MutationUpdatePasswordArgs = {
  newPassword: Scalars['String']['input'];
};


export type MutationUpdatePrintHubClaimArgs = {
  printSettings?: InputMaybe<PrintHubClaimPrintSettingsInputObjectType>;
  printerName?: InputMaybe<Scalars['String']['input']>;
  shopId: Scalars['ObjectId']['input'];
};


export type MutationUpdatePrintHubSettingsArgs = {
  settings: PrintHubSettingsInputObjectType;
  shopId: Scalars['ObjectId']['input'];
};


export type MutationUpdateProductArgs = {
  data: ProductInputObjectType;
  id: Scalars['ObjectId']['input'];
};


export type MutationUpdateQuotaLimitArgs = {
  newLimit?: InputMaybe<Scalars['Int']['input']>;
  organisationId: Scalars['ObjectId']['input'];
  type: QuotaTypeEnumType;
};


export type MutationUpdateResellerArgs = {
  data: ResellerInputObjectType;
  id: Scalars['ObjectId']['input'];
};


export type MutationUpdateReservationArgs = {
  data: UpdateReservationInputObjectType;
  id: Scalars['ObjectId']['input'];
};


export type MutationUpdateReservationStatusArgs = {
  data: UpdateReservationStatusInputObjectType;
  id: Scalars['ObjectId']['input'];
};


export type MutationUpdateServiceLocationArgs = {
  data: ServiceLocationInputObjectType;
  id: Scalars['ObjectId']['input'];
};


export type MutationUpdateServiceLocationsArgs = {
  data: ServiceLocationUpdateManyInputObjectType;
  ids: Array<Scalars['ObjectId']['input']>;
};


export type MutationUpdateShopArgs = {
  data: ShopInputObjectType;
  id: Scalars['ObjectId']['input'];
};


export type MutationUpdateUserPreferencesArgs = {
  data: UserPreferencesInputObjectType;
};


export type MutationUpdateUserRoleArgs = {
  role: Scalars['Int']['input'];
  userId: Scalars['ObjectId']['input'];
};


export type MutationUpsertReservationSettingsArgs = {
  data: ReservationSettingsInputObjectType;
};


export type MutationUpsertWooCommerceIntegrationArgs = {
  apiKey: Scalars['String']['input'];
  apiSecret: Scalars['String']['input'];
  apiUrl: Scalars['String']['input'];
  organisationId: Scalars['ObjectId']['input'];
  shopId: Scalars['ObjectId']['input'];
};


export type MutationUpsertWoytiPreferencesArgs = {
  data: WoytiPreferencesInput;
};

/** A notification. */
export type NotificationObjectType = {
  __typename?: 'NotificationObjectType';
  _id: Scalars['ObjectId']['output'];
  createdAt: Scalars['DateTime']['output'];
  link?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  severity: SeverityEnumType;
  userId: Scalars['ObjectId']['output'];
};

/** Which notification to send to a user and/or customer */
export enum NotificationTypeEnumType {
  /** Send email notification */
  Email = 'email',
  /** Send sms notification */
  Sms = 'sms'
}

/** Data needed to create a nutritional information table. */
export type NutritionalInformationInputObjectType = {
  /** Total amount of added sugars in grams (multiplied by 100 for decimal points) */
  addedSugars: Scalars['Int']['input'];
  /** Total amount of carbohydrate in grams (multiplied by 100 for decimal points) */
  carbohydrate: Scalars['Int']['input'];
  /** Total amount of cholesterol in grams (multiplied by 100 for decimal points) */
  cholesterol: Scalars['Int']['input'];
  /** Total amount of energy in kCal (multiplied by 100 for decimal points) */
  energy: Scalars['Int']['input'];
  /** Total amount of fat in grams (multiplied by 100 for decimal points) */
  fat: Scalars['Int']['input'];
  /** Total amount of fiber in grams (multiplied by 100 for decimal points) */
  fiber: Scalars['Int']['input'];
  /** Total amount of protein in grams (multiplied by 100 for decimal points) */
  protein: Scalars['Int']['input'];
  /** Total amount of salt in grams (multiplied by 100 for decimal points) */
  salt: Scalars['Int']['input'];
  /** Total amount of saturated fat in grams (multiplied by 100 for decimal points) */
  saturatedFat: Scalars['Int']['input'];
  /** Total amount of sugars in grams (multiplied by 100 for decimal points) */
  sugars: Scalars['Int']['input'];
};

/** Data needed to create a nutritional information table. */
export type NutritionalInformationObjectType = {
  __typename?: 'NutritionalInformationObjectType';
  /** Total amount of added sugars in grams (multiplied by 100 for decimal points) */
  addedSugars: Scalars['Int']['output'];
  /** Total amount of carbohydrate in grams (multiplied by 100 for decimal points) */
  carbohydrate: Scalars['Int']['output'];
  /** Total amount of cholesterol in grams (multiplied by 100 for decimal points) */
  cholesterol: Scalars['Int']['output'];
  /** Total amount of energy in kCal (multiplied by 100 for decimal points) */
  energy: Scalars['Int']['output'];
  /** Total amount of fat in grams (multiplied by 100 for decimal points) */
  fat: Scalars['Int']['output'];
  /** Total amount of fiber in grams (multiplied by 100 for decimal points) */
  fiber: Scalars['Int']['output'];
  /** Total amount of protein in grams (multiplied by 100 for decimal points) */
  protein: Scalars['Int']['output'];
  /** Total amount of salt in grams (multiplied by 100 for decimal points) */
  salt: Scalars['Int']['output'];
  /** Total amount of saturated fat in grams (multiplied by 100 for decimal points) */
  saturatedFat: Scalars['Int']['output'];
  /** Total amount of sugars in grams (multiplied by 100 for decimal points) */
  sugars: Scalars['Int']['output'];
};

/** Filters results to match these specified queries. */
export type OrderFilterInputObjectType = {
  /** Filters by order status(es) */
  status?: InputMaybe<Array<OrderStatusEnumType>>;
};

/** Object describing an order line. */
export type OrderLineObjectType = {
  __typename?: 'OrderLineObjectType';
  /** Can this line be paid using Meal Vouchers */
  canUseMealVouchers: Scalars['Boolean']['output'];
  /** Description of the line, this is usually localized in the language of the customer. */
  description: Scalars['String']['output'];
  /** Discount percentage for example 500 for 5% */
  discountPercentage: Scalars['Int']['output'];
  /** The id of the product that is linked to this line */
  productId?: Maybe<Scalars['ObjectId']['output']>;
  /** The total price for the line in cent value */
  totalPrice: Scalars['Int']['output'];
  /** VAT Rate percentage for example 600 for 6% */
  vatRate: Scalars['Int']['output'];
};

/** Object describing an order. */
export type OrderObjectType = {
  __typename?: 'OrderObjectType';
  /** Internal id used for linking with other data-types and to quickly find the product in the database. */
  _id: Scalars['ObjectId']['output'];
  /** Whether the customer can retry payment after a failed attempt. */
  canRetryPayment?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Customer this order is linked to. */
  customer?: Maybe<CustomerObjectType>;
  /** Customer this order is linked to. */
  customerId?: Maybe<Scalars['ObjectId']['output']>;
  /** E-Mail of the customer */
  emails?: Maybe<Array<Scalars['String']['output']>>;
  /** First Name of the customer */
  firstName: Scalars['String']['output'];
  /** Numeric id used purely as a visual representation to the end-user */
  id: Scalars['Int']['output'];
  /** Whether the Mollie checkout was created in test mode */
  isMollieTestMode?: Maybe<Scalars['Boolean']['output']>;
  /** Preferred language of the customer */
  language: LanguageEnum;
  /** Last Name of the customer */
  lastName: Scalars['String']['output'];
  /** Checkout redirect URL for the current payment attempt */
  mollieCheckoutLink?: Maybe<Scalars['String']['output']>;
  /** Mollie Orders API order id stored on the order */
  mollieOrderId?: Maybe<Scalars['String']['output']>;
  /** Mollie Payments API payment id stored on the order */
  molliePaymentId?: Maybe<Scalars['String']['output']>;
  /** Related Mollie payments with live status and dashboard links */
  molliePayments?: Maybe<Array<MolliePaymentSummaryObjectType>>;
  /** The shopper must confirm before unavailable lines are removed. False when removal would leave nothing to pay. */
  mustAcceptLineRemoval?: Maybe<Scalars['Boolean']['output']>;
  /** Amount of times a notification has been sent, ideally this should be 1. */
  notificationsSent: Scalars['Int']['output'];
  /** a list of all order lines */
  orderLines: Array<OrderLineObjectType>;
  /** Legacy copy of shortToken. Still accepted until existing links expire. */
  orderToken: Scalars['String']['output'];
  /** Organisation this order belongs to. Resolved from the order so the public order page does not need an organisation header. */
  organisation?: Maybe<WoytiOrganisationObjectType>;
  organisationId: Scalars['ObjectId']['output'];
  /** Where did the order originate from (e-commerce, manual, ...) */
  origin: Scalars['String']['output'];
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  /** Order page, where the customer can see the order and choose to pay. */
  payLink?: Maybe<Scalars['String']['output']>;
  /** Payment gateway used for this order checkout */
  paymentGateway?: Maybe<PaymentGatewayEnumType>;
  /** Payment method reported after payment (e.g. ideal, bancontact) */
  paymentMethod?: Maybe<Scalars['String']['output']>;
  /** Bancontact/Payconiq QR image src when the kiosk QR shortcut created the checkout */
  paymentQrCodeSrc?: Maybe<Scalars['String']['output']>;
  /** A list of reservation ids, only used for vending orders. */
  pincode?: Maybe<Scalars['String']['output']>;
  /** The amount that has been refunded in cent value */
  refundedAmount: Scalars['Int']['output'];
  /** Product lines the shopper agreed to remove because they were no longer available. */
  removedLineDescriptions?: Maybe<Array<Scalars['String']['output']>>;
  /** A list of reservation ids, only used for vending orders. */
  reservationIds: Array<Scalars['ObjectId']['output']>;
  /** A list of reservation ids, only used for vending orders. */
  reservations: Array<ReservationObjectType>;
  shop: ShopObjectType;
  shopId: Scalars['ObjectId']['output'];
  /** Order page and pay links. New orders use a 10-character nanoid. */
  shortToken?: Maybe<Scalars['String']['output']>;
  /** Current status of the order */
  status: OrderStatusEnumType;
  /** The total value of the order in cent value */
  totalPrice: Scalars['Int']['output'];
  /** Lines that could not be locked again on retry. They stay on the order until the shopper accepts removal. */
  unavailableLineDescriptions?: Maybe<Array<Scalars['String']['output']>>;
  /** If true, this order contains at least one reservation with unboxed: true */
  unboxed?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type OrderPaginatedResultObjectType = {
  __typename?: 'OrderPaginatedResultObjectType';
  /** The amount of items in the response */
  count: Scalars['Int']['output'];
  /** Documents */
  docs: Array<OrderObjectType>;
  /** The defined limit value */
  limit: Scalars['Int']['output'];
  /** The defined skip value */
  skip: Scalars['Int']['output'];
  /** The total amount of documents that match your query */
  total: Scalars['Int']['output'];
};

/** Sort the results based on the value of this object */
export type OrderSortInputObjectType = {
  /** Sort based on the value: _id */
  _id?: InputMaybe<SortEnumType>;
  /** Sort based on the value: firstName */
  firstName?: InputMaybe<SortEnumType>;
  /** Sort based on the value: lastName */
  lastName?: InputMaybe<SortEnumType>;
  /** Sort based on the value: origin */
  origin?: InputMaybe<SortEnumType>;
  /** Sort based on the value: status */
  status?: InputMaybe<SortEnumType>;
};

/** The status of a given order */
export enum OrderStatusEnumType {
  /** Order has been canceled manually */
  Canceled = 'Canceled',
  /** Order has been created, not paid */
  Created = 'Created',
  /** Order has expired */
  Expired = 'Expired',
  /** Order has been paid */
  Paid = 'Paid',
  /** Pending order payment has been canceled */
  PaymentCanceled = 'PaymentCanceled',
  /** Pending order payment has been expired */
  PaymentExpired = 'PaymentExpired',
  /** Order has been refunded, this can only be done manually in the Mollie dashboard */
  Refunded = 'Refunded'
}

/** Aggregation period for order summaries */
export enum OrderSummaryPeriodEnumType {
  /** Aggregate by day */
  Day = 'Day',
  /** Aggregate by month */
  Month = 'Month',
  /** Aggregate by week */
  Week = 'Week',
  /** Aggregate by weekday */
  Weekday = 'Weekday'
}

/** Order summary for a single month, split by origin (flat structure) */
export type OrderSummaryRowObjectType = {
  __typename?: 'OrderSummaryRowObjectType';
  label: Scalars['String']['output'];
  manualCancelledAmount: Scalars['Int']['output'];
  manualCancelledCount: Scalars['Int']['output'];
  manualCompletedAmount: Scalars['Int']['output'];
  manualCompletedCount: Scalars['Int']['output'];
  vendingCancelledAmount: Scalars['Int']['output'];
  vendingCancelledCount: Scalars['Int']['output'];
  vendingCompletedAmount: Scalars['Int']['output'];
  vendingCompletedCount: Scalars['Int']['output'];
};

/** Email settings for an organisation. */
export type OrganisationEmailSettingsInputObjectType = {
  fromEmail: Scalars['String']['input'];
  password: Scalars['String']['input'];
  smtpPort: Scalars['Int']['input'];
  smtpServer: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

/** Email settings for an organisation. */
export type OrganisationEmailSettingsObjectType = {
  __typename?: 'OrganisationEmailSettingsObjectType';
  fromEmail: Scalars['String']['output'];
  password: Scalars['String']['output'];
  smtpPort: Scalars['Int']['output'];
  smtpServer: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

/** Information required to create or update an organisation. */
export type OrganisationInputObjectType = {
  address: AddressInputObjectType;
  companyName: Scalars['String']['input'];
  dealerId: Scalars['ObjectId']['input'];
  email: Scalars['String']['input'];
  language: LanguageEnum;
  name: Scalars['String']['input'];
  phonenumber: Scalars['PhoneNumber']['input'];
  registrationNumber: Scalars['String']['input'];
  vatNumber: Scalars['String']['input'];
};

/** Information required to create or update an organisation. */
export type OrganisationJoynSettingsInputObjectType = {
  joynSharedSecret?: InputMaybe<Scalars['String']['input']>;
  joynShopReference?: InputMaybe<Scalars['String']['input']>;
};

/** Information about an organisation. */
export type OrganisationObjectType = {
  __typename?: 'OrganisationObjectType';
  _id: Scalars['ObjectId']['output'];
  address: AddressObjectType;
  brandColor: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  dealer?: Maybe<DealerObjectType>;
  dealerId: Scalars['ObjectId']['output'];
  email: Scalars['String']['output'];
  emailSettings?: Maybe<OrganisationEmailSettingsObjectType>;
  /** External id used to identify viresmo organisations, this id gets put on invoices */
  id: Scalars['Int']['output'];
  joynSharedSecret?: Maybe<Scalars['String']['output']>;
  joynShopReference?: Maybe<Scalars['String']['output']>;
  /** Kiosk Bancontact/Payconiq QR shortcut preference. Default follows the code default (currently QR). */
  kioskPaymentQrMode: KioskPaymentQrModeEnumType;
  language: LanguageEnum;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pathname: Scalars['String']['output'];
  /** Checkout provider used for new orders */
  paymentGateway: PaymentGatewayEnumType;
  phonenumber: Scalars['PhoneNumber']['output'];
  qualityGuardContractId?: Maybe<Scalars['Int']['output']>;
  qualityGuardKey?: Maybe<Scalars['String']['output']>;
  registrationNumber: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vatNumber: Scalars['String']['output'];
};

export type OrganisationPaginatedResultObjectType = {
  __typename?: 'OrganisationPaginatedResultObjectType';
  /** The amount of items in the response */
  count: Scalars['Int']['output'];
  /** Documents */
  docs: Array<OrganisationObjectType>;
  /** The defined limit value */
  limit: Scalars['Int']['output'];
  /** The defined skip value */
  skip: Scalars['Int']['output'];
  /** The total amount of documents that match your query */
  total: Scalars['Int']['output'];
};

/** Information required to update quality guard settings for an organisation. */
export type OrganisationQualityGuardSettingsInputObjectType = {
  qualityGuardContractId?: InputMaybe<Scalars['Int']['input']>;
  qualityGuardKey?: InputMaybe<Scalars['String']['input']>;
};

/** Information required to create or update an organisation. */
export type OrganisationSettingsInputObjectType = {
  address: AddressInputObjectType;
  companyName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  language: LanguageEnum;
  name: Scalars['String']['input'];
  phonenumber: Scalars['PhoneNumber']['input'];
  registrationNumber: Scalars['String']['input'];
  vatNumber: Scalars['String']['input'];
};

/** Object used for creating/updating an overwrite code */
export type OverwriteCodeInputObjectType = {
  /** Name for the overwrite code, usually the name of the employee */
  name: Scalars['String']['input'];
  /** Pincode used to open the locker */
  pincode: Scalars['String']['input'];
  /** internal shop id */
  shopId: Scalars['ObjectId']['input'];
};

/** Overwrite code, these codes can open any lock in a locker */
export type OverwriteCodeObjectType = {
  __typename?: 'OverwriteCodeObjectType';
  /** Internal id used for linking to other objects and getting this object */
  _id: Scalars['ObjectId']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Name for the overwrite code, usually the name of the employee */
  name: Scalars['String']['output'];
  /** Pincode used to open the locker */
  pincode: Scalars['String']['output'];
  /** Shop */
  shop: ShopObjectType;
  /** Shop ID, points to the shop this service location belongs to */
  shopId: Scalars['ObjectId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type OverwriteCodePaginatedResultObjectType = {
  __typename?: 'OverwriteCodePaginatedResultObjectType';
  /** The amount of items in the response */
  count: Scalars['Int']['output'];
  /** Documents */
  docs: Array<OverwriteCodeObjectType>;
  /** The defined limit value */
  limit: Scalars['Int']['output'];
  /** The defined skip value */
  skip: Scalars['Int']['output'];
  /** The total amount of documents that match your query */
  total: Scalars['Int']['output'];
};

export type PaginatedAnnouncementObjectType = {
  __typename?: 'PaginatedAnnouncementObjectType';
  /** The amount of items in the response */
  count: Scalars['Int']['output'];
  /** Documents */
  docs: Array<AnnouncementObjectType>;
  /** The defined limit value */
  limit: Scalars['Int']['output'];
  /** The defined skip value */
  skip: Scalars['Int']['output'];
  /** The total amount of documents that match your query */
  total: Scalars['Int']['output'];
};

export type PaginatedBillingLogResultObjectType = {
  __typename?: 'PaginatedBillingLogResultObjectType';
  /** The amount of items in the response */
  count: Scalars['Int']['output'];
  /** Documents */
  docs: Array<BillingLogObjectType>;
  /** The defined limit value */
  limit: Scalars['Int']['output'];
  /** The defined skip value */
  skip: Scalars['Int']['output'];
  /** The total amount of documents that match your query */
  total: Scalars['Int']['output'];
};

export type PaginatedDealerResultObjectType = {
  __typename?: 'PaginatedDealerResultObjectType';
  /** The amount of items in the response */
  count: Scalars['Int']['output'];
  /** Documents */
  docs: Array<DealerObjectType>;
  /** The defined limit value */
  limit: Scalars['Int']['output'];
  /** The defined skip value */
  skip: Scalars['Int']['output'];
  /** The total amount of documents that match your query */
  total: Scalars['Int']['output'];
};

export type PaginatedLockerTemperatureResultObjectType = {
  __typename?: 'PaginatedLockerTemperatureResultObjectType';
  /** The amount of items in the response */
  count: Scalars['Int']['output'];
  /** Documents */
  docs: Array<LockerTemperatureObjectType>;
  /** The defined limit value */
  limit: Scalars['Int']['output'];
  /** The defined skip value */
  skip: Scalars['Int']['output'];
  /** The total amount of documents that match your query */
  total: Scalars['Int']['output'];
};

export type PaginatedNotificationsObjectType = {
  __typename?: 'PaginatedNotificationsObjectType';
  /** The amount of items in the response */
  count: Scalars['Int']['output'];
  /** Documents */
  docs: Array<NotificationObjectType>;
  /** The defined limit value */
  limit: Scalars['Int']['output'];
  /** The defined skip value */
  skip: Scalars['Int']['output'];
  /** The total amount of documents that match your query */
  total: Scalars['Int']['output'];
};

export type PaginatedResellerResultObjectType = {
  __typename?: 'PaginatedResellerResultObjectType';
  /** The amount of items in the response */
  count: Scalars['Int']['output'];
  /** Documents */
  docs: Array<ResellerObjectType>;
  /** The defined limit value */
  limit: Scalars['Int']['output'];
  /** The defined skip value */
  skip: Scalars['Int']['output'];
  /** The total amount of documents that match your query */
  total: Scalars['Int']['output'];
};

export type PaginatedUsageLedgerEntriesObjectType = {
  __typename?: 'PaginatedUsageLedgerEntriesObjectType';
  /** The amount of items in the response */
  count: Scalars['Int']['output'];
  /** Documents */
  docs: Array<UsageLedgerEntryObjectType>;
  /** The defined limit value */
  limit: Scalars['Int']['output'];
  /** The defined skip value */
  skip: Scalars['Int']['output'];
  /** The total amount of documents that match your query */
  total: Scalars['Int']['output'];
};

/** Define page size and offset, limited to 100 elements */
export type PaginationInputObjectType = {
  /** Maximum amount of elements to return */
  limit?: Scalars['Int']['input'];
  /** Amount of elements to skip */
  skip?: Scalars['Int']['input'];
};

/** Checkout provider for an organisation */
export enum PaymentGatewayEnumType {
  /** Worldline Bancontact — direct integration, not yet available */
  Bancontact = 'Bancontact',
  /** Mollie Orders (uses Mollie Connect) */
  MollieOrders = 'MollieOrders',
  /** Mollie Payments (uses Mollie Connect) */
  MolliePayments = 'MolliePayments',
  /** Local test gateway — no external PSP */
  Sandbox = 'Sandbox',
  /** Stripe Checkout on the organisation connected account */
  Stripe = 'Stripe'
}

export type PrintHubClaimObjectType = {
  __typename?: 'PrintHubClaimObjectType';
  charsPerLine?: Maybe<Scalars['Int']['output']>;
  claimedAt: Scalars['DateTime']['output'];
  dpi?: Maybe<Scalars['Int']['output']>;
  font?: Maybe<PrintHubEscPosFontEnum>;
  labelHeightMm?: Maybe<Scalars['Int']['output']>;
  labelWidthMm?: Maybe<Scalars['Int']['output']>;
  organisationId: Scalars['ObjectId']['output'];
  paperWidthMm?: Maybe<Scalars['Int']['output']>;
  printerName: Scalars['String']['output'];
  shop?: Maybe<ShopObjectType>;
  shopId: Scalars['ObjectId']['output'];
};

export type PrintHubClaimPrintSettingsInputObjectType = {
  charsPerLine?: InputMaybe<Scalars['Int']['input']>;
  dpi?: InputMaybe<Scalars['Int']['input']>;
  font?: InputMaybe<PrintHubEscPosFontEnum>;
  labelHeightMm?: InputMaybe<Scalars['Int']['input']>;
  labelWidthMm?: InputMaybe<Scalars['Int']['input']>;
  paperWidthMm?: InputMaybe<Scalars['Int']['input']>;
};

export type PrintHubClaimableShopObjectType = {
  __typename?: 'PrintHubClaimableShopObjectType';
  _id: Scalars['ObjectId']['output'];
  name: Scalars['String']['output'];
  organisationId: Scalars['ObjectId']['output'];
  organisationName: Scalars['String']['output'];
};

export enum PrintHubEscPosFontEnum {
  A = 'A',
  B = 'B'
}

export type PrintHubEscPosSuggestionObjectType = {
  __typename?: 'PrintHubEscPosSuggestionObjectType';
  hint?: Maybe<Scalars['String']['output']>;
  knownModel: Scalars['Boolean']['output'];
  suggestedCharsPerLine?: Maybe<Scalars['Int']['output']>;
  supportsFontB: Scalars['Boolean']['output'];
};

export type PrintHubLayoutPreviewInputObjectType = {
  customerName?: InputMaybe<Scalars['String']['input']>;
  duplicateLabel?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  includeDocument?: InputMaybe<Scalars['Boolean']['input']>;
  lines?: InputMaybe<Array<InputMaybe<PrintHubLayoutPreviewLineInputObjectType>>>;
  orderNumber?: InputMaybe<Scalars['Int']['input']>;
  paidAt?: InputMaybe<Scalars['String']['input']>;
  printSettings?: InputMaybe<PrintHubClaimPrintSettingsInputObjectType>;
  printerName: Scalars['String']['input'];
  totalPrice?: InputMaybe<Scalars['Int']['input']>;
};

export type PrintHubLayoutPreviewLineInputObjectType = {
  description: Scalars['String']['input'];
  totalPrice: Scalars['Int']['input'];
};

export type PrintHubLayoutPreviewObjectType = {
  __typename?: 'PrintHubLayoutPreviewObjectType';
  documentBase64?: Maybe<Scalars['String']['output']>;
  documentFormat?: Maybe<Scalars['String']['output']>;
  format: Scalars['String']['output'];
  heightPx: Scalars['Int']['output'];
  previewPngBase64: Scalars['String']['output'];
  widthPx: Scalars['Int']['output'];
};

export type PrintHubObjectType = {
  __typename?: 'PrintHubObjectType';
  _id: Scalars['ObjectId']['output'];
  claims: Array<PrintHubClaimObjectType>;
  createdAt: Scalars['DateTime']['output'];
  hostname?: Maybe<Scalars['String']['output']>;
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  lastSeenBuildTime?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  online: Scalars['Boolean']['output'];
  platform?: Maybe<Scalars['String']['output']>;
  printers: Array<PrintHubPrinterObjectType>;
  settings: PrintHubSettingsObjectType;
  trayUpdateRequired: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PrintHubPrinterObjectType = {
  __typename?: 'PrintHubPrinterObjectType';
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type PrintHubPrinterSuggestionsObjectType = {
  __typename?: 'PrintHubPrinterSuggestionsObjectType';
  dialect: Scalars['String']['output'];
  escpos: PrintHubEscPosSuggestionObjectType;
  zplPresets: Array<PrintHubZplPresetObjectType>;
};

export type PrintHubSettingsInputObjectType = {
  maxPrintAttempts?: InputMaybe<Scalars['Int']['input']>;
  minTrayBuildTime?: InputMaybe<Scalars['String']['input']>;
  pollInterval?: InputMaybe<Scalars['Int']['input']>;
  startedJobTimeout?: InputMaybe<Scalars['Int']['input']>;
  trayUpdateMessage?: InputMaybe<Scalars['String']['input']>;
  trayUpdateUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PrintHubSettingsObjectType = {
  __typename?: 'PrintHubSettingsObjectType';
  maxPrintAttempts: Scalars['Int']['output'];
  minTrayBuildTime?: Maybe<Scalars['String']['output']>;
  pollInterval: Scalars['Int']['output'];
  startedJobTimeout: Scalars['Int']['output'];
  trayUpdateMessage?: Maybe<Scalars['String']['output']>;
  trayUpdateUrl?: Maybe<Scalars['String']['output']>;
};

export type PrintHubZplPresetObjectType = {
  __typename?: 'PrintHubZplPresetObjectType';
  dpi: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  labelHeightMm: Scalars['Int']['output'];
  labelWidthMm: Scalars['Int']['output'];
};

/** Data about an item in a product collection */
export type ProductCollectionItemInputObjectType = {
  /** The amount of the product. */
  amount: Scalars['Int']['input'];
  /** The ID of the product */
  productId: Scalars['ObjectId']['input'];
};

/** Data about an item in a product collection */
export type ProductCollectionItemObjectType = {
  __typename?: 'ProductCollectionItemObjectType';
  /** The amount of the product. */
  amount: Scalars['Int']['output'];
  /** The ID of the product */
  product?: Maybe<ProductObjectType>;
  /** The ID of the product */
  productId: Scalars['ObjectId']['output'];
};

/** Data needed to create or edit a product. */
export type ProductInputObjectType = {
  /** Allergens information for the product */
  allergens: Array<AllergensEnumType>;
  /** Can this product be paid using dinner cheques? */
  canUseMealVouchers: Scalars['Boolean']['input'];
  /** Description of the product */
  description: Array<LocalisedStringInputObjectType>;
  /** True if a product has nutritional information */
  hasNutritionalInformation?: Scalars['Boolean']['input'];
  /**
   * A google storage file key where the image is stored, for further processing
   * and linking (this has to be in the upload bucket of viresmo)
   */
  imageObjectKey?: InputMaybe<Scalars['String']['input']>;
  /** A url to an image (max 25MB) */
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  /** A list of products that are included in this product */
  includedProducts?: InputMaybe<Array<ProductCollectionItemInputObjectType>>;
  /** The interval with which the amount will be incremented or decremented */
  interval: Scalars['Int']['input'];
  /** Minimum amount a customer has to buy */
  minimumAmount: Scalars['Int']['input'];
  /** Name of the product */
  name: Array<LocalisedStringInputObjectType>;
  /** Nutritional information for the product */
  nutritionalInformation: NutritionalInformationInputObjectType;
  /** PLU of the product */
  plu?: InputMaybe<Scalars['String']['input']>;
  /** The price per interval (multiplied by 100 to be able to represent decimal points) */
  price: Scalars['Int']['input'];
  /** Unit to represent the volume of product */
  unitType: UnitEnumType;
  /** VAT Rate for the product, multiplied by 100, example 6% = 600 */
  vatRate: Scalars['Int']['input'];
};

/** Object describing a product. */
export type ProductObjectType = {
  __typename?: 'ProductObjectType';
  /** Internal id used for linking with other data-types and to quickly find the product in the database. */
  _id: Scalars['ObjectId']['output'];
  /** Allergens information for the product */
  allergens: Array<AllergensEnumType>;
  /** Combined allergens: product allergens + QualityGuard allergens (cached by PLU). Use for customer-facing views. */
  allergensCombined: Array<AllergensEnumType>;
  /** Can this product be paid using dinner cheques? */
  canUseMealVouchers: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Description of the product */
  description: Array<LocalisedStringObjectType>;
  /** True if a product has nutritional information */
  hasNutritionalInformation: Scalars['Boolean']['output'];
  /** Numeric id used purely as a visual representation to the end-user */
  id: Scalars['Int']['output'];
  /** Image of the product */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** A list of products that are included in this product */
  includedProducts: Array<ProductCollectionItemObjectType>;
  /** The interval with which the amount will be incremented or decremented */
  interval: Scalars['Int']['output'];
  /** Minimum amount a customer has to buy */
  minimumAmount: Scalars['Int']['output'];
  /** Name of the product */
  name: Array<LocalisedStringObjectType>;
  /** Nutritional information for the product */
  nutritionalInformation: NutritionalInformationObjectType;
  /** PLU of the product */
  plu?: Maybe<Scalars['String']['output']>;
  /** The price per interval */
  price: Scalars['Int']['output'];
  /** Allergens from QualityGuard (cached by PLU). Separate from product allergens. */
  qualityGuardAllergens?: Maybe<Array<Maybe<AllergensEnumType>>>;
  /** When QualityGuard allergens were last fetched */
  qualityGuardAllergensFetchedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Unit to represent the volume of product */
  unitType: UnitEnumType;
  updatedAt: Scalars['DateTime']['output'];
  /** VAT Rate for the product, multiplied by 100, example 6% = 600 */
  vatRate: Scalars['Int']['output'];
};

export type ProductPaginatedResultObjectType = {
  __typename?: 'ProductPaginatedResultObjectType';
  /** The amount of items in the response */
  count: Scalars['Int']['output'];
  /** Documents */
  docs: Array<ProductObjectType>;
  /** The defined limit value */
  limit: Scalars['Int']['output'];
  /** The defined skip value */
  skip: Scalars['Int']['output'];
  /** The total amount of documents that match your query */
  total: Scalars['Int']['output'];
};

/** Sort the results based on the value of this object */
export type ProductSortInputObjectType = {
  /** Sort based on the value: _id */
  _id?: InputMaybe<SortEnumType>;
};

/** Allergen information from QualityGuard. */
export type QualityGuardAllergenObjectType = {
  __typename?: 'QualityGuardAllergenObjectType';
  code?: Maybe<Scalars['String']['output']>;
  legalAllergen?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<QualityGuardRecipeNameObjectType>;
  presence?: Maybe<Scalars['String']['output']>;
};

/** Paginated response for recipe categories from QualityGuard API. */
export type QualityGuardCategoriesPaginatedObjectType = {
  __typename?: 'QualityGuardCategoriesPaginatedObjectType';
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<Maybe<QualityGuardRecipeCategoryObjectType>>>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

/** Image information from QualityGuard. */
export type QualityGuardImageObjectType = {
  __typename?: 'QualityGuardImageObjectType';
  fileData?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
};

/** Ingredient information from QualityGuard. */
export type QualityGuardIngredientObjectType = {
  __typename?: 'QualityGuardIngredientObjectType';
  articleNumber?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  quantityUnit?: Maybe<Scalars['String']['output']>;
  supplierName?: Maybe<Scalars['String']['output']>;
};

/** Nutrient information from QualityGuard. */
export type QualityGuardNutrientObjectType = {
  __typename?: 'QualityGuardNutrientObjectType';
  UoM?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** Quantity with unit from QualityGuard. */
export type QualityGuardQuantityObjectType = {
  __typename?: 'QualityGuardQuantityObjectType';
  quantity?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

/** Recipe category information. */
export type QualityGuardRecipeCategoryObjectType = {
  __typename?: 'QualityGuardRecipeCategoryObjectType';
  de_DE?: Maybe<Scalars['String']['output']>;
  en_GB?: Maybe<Scalars['String']['output']>;
  fr_FR?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  nl_BE?: Maybe<Scalars['String']['output']>;
};

/** Detailed recipe information from QualityGuard API. */
export type QualityGuardRecipeInfoObjectType = {
  __typename?: 'QualityGuardRecipeInfoObjectType';
  active?: Maybe<Scalars['Boolean']['output']>;
  allergens?: Maybe<Array<Maybe<QualityGuardAllergenObjectType>>>;
  batchWeight?: Maybe<QualityGuardQuantityObjectType>;
  id: Scalars['Int']['output'];
  image?: Maybe<QualityGuardImageObjectType>;
  ingredients?: Maybe<Array<Maybe<QualityGuardIngredientObjectType>>>;
  isIntermediateGood?: Maybe<Scalars['Boolean']['output']>;
  lastModified?: Maybe<Scalars['String']['output']>;
  name?: Maybe<QualityGuardRecipeNameObjectType>;
  nutrients?: Maybe<Array<Maybe<QualityGuardNutrientObjectType>>>;
  plu: Scalars['String']['output'];
  preparationDescription?: Maybe<QualityGuardRecipeNameObjectType>;
  price?: Maybe<Scalars['String']['output']>;
  recipeCategory?: Maybe<QualityGuardRecipeCategoryObjectType>;
  salesItem?: Maybe<QualityGuardQuantityObjectType>;
  shelfLife?: Maybe<QualityGuardQuantityObjectType>;
  stock?: Maybe<QualityGuardQuantityObjectType>;
  stockWeight?: Maybe<QualityGuardQuantityObjectType>;
  storageTemperature?: Maybe<QualityGuardTemperatureObjectType>;
  totalWeight?: Maybe<QualityGuardQuantityObjectType>;
  validated?: Maybe<Scalars['Boolean']['output']>;
  weightLoss?: Maybe<QualityGuardQuantityObjectType>;
};

/** Recipe name in different locales. */
export type QualityGuardRecipeNameObjectType = {
  __typename?: 'QualityGuardRecipeNameObjectType';
  de_DE?: Maybe<Scalars['String']['output']>;
  en_GB?: Maybe<Scalars['String']['output']>;
  fr_FR?: Maybe<Scalars['String']['output']>;
  nl_BE?: Maybe<Scalars['String']['output']>;
};

/** A recipe from QualityGuard. */
export type QualityGuardRecipeObjectType = {
  __typename?: 'QualityGuardRecipeObjectType';
  active?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  isIntermediateGood?: Maybe<Scalars['Boolean']['output']>;
  lastModified?: Maybe<Scalars['String']['output']>;
  name?: Maybe<QualityGuardRecipeNameObjectType>;
  plu?: Maybe<Scalars['String']['output']>;
  /** Resolved product from our DB matching this recipe PLU. */
  product?: Maybe<ProductObjectType>;
  recipeCategory?: Maybe<QualityGuardRecipeCategoryObjectType>;
  shared?: Maybe<Scalars['Boolean']['output']>;
  validated?: Maybe<Scalars['Boolean']['output']>;
};

/** Paginated response for recipes from QualityGuard API. */
export type QualityGuardRecipesPaginatedObjectType = {
  __typename?: 'QualityGuardRecipesPaginatedObjectType';
  hasNextPage: Scalars['Boolean']['output'];
  items?: Maybe<Array<Maybe<QualityGuardRecipeObjectType>>>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

/** Summary of recipes from QualityGuard API. */
export type QualityGuardSummaryObjectType = {
  __typename?: 'QualityGuardSummaryObjectType';
  /** All recipe categories from QualityGuard API. */
  categories?: Maybe<QualityGuardCategoriesPaginatedObjectType>;
  /** Paginated recipes from QualityGuard API. */
  recipes?: Maybe<QualityGuardRecipesPaginatedObjectType>;
};

/** Temperature range from QualityGuard. */
export type QualityGuardTemperatureObjectType = {
  __typename?: 'QualityGuardTemperatureObjectType';
  from?: Maybe<Scalars['Float']['output']>;
  till?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  /** List all service locations based on arguments provided */
  allServiceLocations?: Maybe<ServiceLocationPaginatedResultObjectType>;
  /** List all announcements */
  announcements?: Maybe<PaginatedAnnouncementObjectType>;
  /** List all api keys */
  apiKeys?: Maybe<ApiKeyPaginatedResultObjectType>;
  /** List billing logs. */
  billingLogs?: Maybe<PaginatedBillingLogResultObjectType>;
  /** Return all customers, can be paginated and sorted using the arguments */
  customers?: Maybe<CustomerPaginatedResultObjectType>;
  /** Get the dealer by id. */
  dealer?: Maybe<DealerObjectType>;
  /** Get the users of a dealer by id. */
  dealerUsers?: Maybe<UserPaginatedResultObjectType>;
  /** List dealers. */
  dealers?: Maybe<PaginatedDealerResultObjectType>;
  /** List all device logs. */
  deviceLogs?: Maybe<DeviceLogPaginatedResultObjectType>;
  /** Search for customers using a query. This matches customers by name, email and phonenumber. */
  findCustomers: Array<CustomerObjectType>;
  /** Finds lockers using a query */
  findLockers: Array<LockerObjectType>;
  /** Get a billing log by id. */
  findOneBillingLogById?: Maybe<BillingLogObjectType>;
  /** Search for orders using a query. This matches orders by name and id. */
  findOrders: Array<OrderObjectType>;
  /** Search for organisations using a query. This matches organisations by name, invoice email, id and company name. */
  findOrganisations: Array<OrganisationObjectType>;
  /** Search for overwrite codes using a query. */
  findOverwriteCodes: Array<OverwriteCodeObjectType>;
  /** Search for products using a query. This matches products by name and id. */
  findProducts: Array<ProductObjectType>;
  /** Search for reservations using a query. */
  findReservations: Array<ReservationObjectType>;
  /** Search for service locations using a query. */
  findServiceLocations: Array<ServiceLocationObjectType>;
  /** Search for shop using a query. */
  findShops: Array<ShopObjectType>;
  /** Return all firmware versions, can be paginated and sorted using the arguments */
  firmwareVersions?: Maybe<FirmwareVersionPaginatedResultObjectType>;
  /** Get an announcement by id */
  getAnnouncementById?: Maybe<AnnouncementObjectType>;
  /** Get an api key by id */
  getApiKeyById?: Maybe<ApiKeyObjectType>;
  /** Get the organisation the user is currently logged in to. */
  getCurrentOrganisation?: Maybe<OrganisationObjectType>;
  getCurrentUser?: Maybe<UserObjectType>;
  /** Get a customer by the internal id, used within the viresmo platform. */
  getCustomerById?: Maybe<CustomerObjectType>;
  /** Get a single device log by it's unique id */
  getDeviceLogById?: Maybe<DeviceLogObjectType>;
  getDispatchWoytiNotificationsCount: Scalars['Int']['output'];
  /** Get a locker by using our internal id */
  getLockerById?: Maybe<LockerObjectType>;
  /** Get a single log item by the unique id */
  getLogItemById?: Maybe<LogItemObjectType>;
  /** Get an order by the internal id, used within the viresmo platform. */
  getOrderById?: Maybe<OrderObjectType>;
  /** Get an order by orderToken. Used by the shop order page. */
  getOrderByOrderToken?: Maybe<OrderObjectType>;
  /** Get an order by shortToken. Used by the shop order page. */
  getOrderByShortToken?: Maybe<OrderObjectType>;
  /** Get an order by the internal id, used within the viresmo platform. */
  getOrderByTokenAndId?: Maybe<OrderObjectType>;
  /** Get the organisation that matches the provided organisationId. */
  getOrganisationById?: Maybe<OrganisationObjectType>;
  /** @deprecated Use getOrganisationByWoytiPathname instead */
  getOrganisationByWoytiPathname?: Maybe<WoytiOrganisationObjectType>;
  getOrganisationWoytiShops: WoytiShopPaginatedResultObjectType;
  /** Get a single overwrite code based on an internal id */
  getOverwriteCodeById?: Maybe<OverwriteCodeObjectType>;
  /** Get a product by the internal id, used within the viresmo platform. */
  getProductById?: Maybe<ProductObjectType>;
  /** Get a summary of recipes from QualityGuard API for an organisation. */
  getQualityGuardSummary?: Maybe<QualityGuardSummaryObjectType>;
  /** Used to get the reservation that matches the internal id provided */
  getReservationById?: Maybe<ReservationObjectType>;
  /** Used to get the reservation that matches the internal id and token provided */
  getReservationByIdAndToken?: Maybe<ReservationObjectType>;
  /** Get a single service location based on an internal id */
  getServiceLocationById?: Maybe<ServiceLocationObjectType>;
  /** Get a single shop based on an internal id */
  getShopById?: Maybe<ShopObjectType>;
  /** Used to get the latest stable firmware version */
  getStableFirmwareVersion?: Maybe<FirmwareVersionObjectType>;
  getUserById?: Maybe<UserObjectType>;
  getWoytiFavoriteCount?: Maybe<Scalars['Int']['output']>;
  getWoytiReservationsByShopId: Array<WoytiReservationObjectType>;
  getWoytiShopById?: Maybe<WoytiShopObjectType>;
  getWoytiShoppingCart: Array<WoytiReservationObjectType>;
  getWoytiShops: WoytiShopPaginatedResultObjectType;
  /** Request an link to connect Mollie. */
  listMollieProfiles: Array<MollieConnectProfileObjectType>;
  /** Returns daily temperature-check metrics for a locker (hold-forward interpretation). Prefer this over paging lockerTemperatures for compliance views. */
  lockerTemperatureSummary: LockerTemperatureSummaryObjectType;
  /** Returns a list of all locker temperatures, can be paginated using the arguments */
  lockerTemperatures?: Maybe<PaginatedLockerTemperatureResultObjectType>;
  /** Returns a list of all lockers, can be paginated using the arguments */
  lockers?: Maybe<LockerPaginatedResultObjectType>;
  /** List all logs */
  logs?: Maybe<LogPaginatedResultObjectType>;
  /** Request the Mollie connection status. */
  mollieConnectStatus?: Maybe<MollieConnectStatusObjectType>;
  /** Lists all notifications, you can specify the arguments to define sorting and pagination */
  notifications?: Maybe<PaginatedNotificationsObjectType>;
  /** Get aggregated order summary by month, split by status and origin */
  orderSummary: Array<OrderSummaryRowObjectType>;
  /** Return all orders, can be paginated and sorted using the arguments */
  orders?: Maybe<OrderPaginatedResultObjectType>;
  organisationUsers?: Maybe<UserPaginatedResultObjectType>;
  /** List organisations. */
  organisations?: Maybe<OrganisationPaginatedResultObjectType>;
  /** List overwrite codes based on arguments provided */
  overwriteCodes?: Maybe<OverwriteCodePaginatedResultObjectType>;
  printHubClaimPreview?: Maybe<PrintHubObjectType>;
  printHubClaimableShops: Array<PrintHubClaimableShopObjectType>;
  printHubLayoutPreview: PrintHubLayoutPreviewObjectType;
  printHubPrinterSuggestions: PrintHubPrinterSuggestionsObjectType;
  /** Return all products, can be paginated and sorted using the arguments */
  products?: Maybe<ProductPaginatedResultObjectType>;
  /** Get detailed recipe information from QualityGuard API by PLU. */
  qualityGuardRecipe?: Maybe<QualityGuardRecipeInfoObjectType>;
  /** Get the current quota usages */
  quotaUsages: Array<Maybe<QuotaUsageObjectType>>;
  /** Get the reseller by id. */
  reseller?: Maybe<ResellerObjectType>;
  /** Get the users of a reseller by id. */
  resellerUsers?: Maybe<UserPaginatedResultObjectType>;
  /** List resellers. */
  resellers?: Maybe<PaginatedResellerResultObjectType>;
  /** Get the current quota usages */
  reservationSettings?: Maybe<ReservationSettingsObjectType>;
  /** Used for listing all reservations matching the arguments provided */
  reservations?: Maybe<ReservationPaginatedResultObjectType>;
  searchAddress: Array<AddressObjectType>;
  /** List service locations based on arguments provided */
  serviceLocations?: Maybe<ServiceLocationPaginatedResultObjectType>;
  shopPrintHubStatus: ShopPrintHubStatusObjectType;
  /** List shops based on arguments provided */
  shops: ShopPaginatedResultObjectType;
  /** Stripe Connect status for the current organisation. */
  stripeConnectStatus?: Maybe<StripeConnectStatusObjectType>;
  /** Paginate the usage ledger entries */
  usageLedgerEntries: PaginatedUsageLedgerEntriesObjectType;
  /** Fetch the woocommerce integration config. */
  woocommerceIntegration?: Maybe<WooCommerceIntegrationObjectType>;
};


export type QueryAllServiceLocationsArgs = {
  filter?: InputMaybe<ServiceLocationFilterInputObjectType>;
  pagination?: PaginationInputObjectType;
};


export type QueryAnnouncementsArgs = {
  pagination: PaginationInputObjectType;
};


export type QueryApiKeysArgs = {
  pagination: PaginationInputObjectType;
};


export type QueryBillingLogsArgs = {
  pagination?: PaginationInputObjectType;
};


export type QueryCustomersArgs = {
  pagination?: PaginationInputObjectType;
  shopId?: InputMaybe<Scalars['ObjectId']['input']>;
  sort?: InputMaybe<CustomerSortInputObjectType>;
};


export type QueryDealerArgs = {
  id: Scalars['ObjectId']['input'];
};


export type QueryDealerUsersArgs = {
  dealerId: Scalars['ObjectId']['input'];
  pagination?: PaginationInputObjectType;
};


export type QueryDealersArgs = {
  filter?: DealerFilterInputObjectType;
  pagination?: PaginationInputObjectType;
};


export type QueryDeviceLogsArgs = {
  filter?: InputMaybe<DeviceLogFilterInputObjectType>;
  pagination?: PaginationInputObjectType;
  sort?: InputMaybe<DeviceLogSortInputObjectType>;
};


export type QueryFindCustomersArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
  returnOnEmptyQuery?: InputMaybe<Scalars['Boolean']['input']>;
  shopId?: InputMaybe<Scalars['ObjectId']['input']>;
};


export type QueryFindLockersArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
  returnOnEmptyQuery?: InputMaybe<Scalars['Boolean']['input']>;
  shopId?: InputMaybe<Scalars['ObjectId']['input']>;
};


export type QueryFindOneBillingLogByIdArgs = {
  id: Scalars['ObjectId']['input'];
};


export type QueryFindOrdersArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
  returnOnEmptyQuery?: InputMaybe<Scalars['Boolean']['input']>;
  shopId: Scalars['ObjectId']['input'];
};


export type QueryFindOrganisationsArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
  returnOnEmptyQuery?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFindOverwriteCodesArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
  returnOnEmptyQuery?: InputMaybe<Scalars['Boolean']['input']>;
  shopId?: InputMaybe<Scalars['ObjectId']['input']>;
};


export type QueryFindProductsArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
  returnOnEmptyQuery?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFindReservationsArgs = {
  filter?: InputMaybe<ReservationFilterInputObjectType>;
  query?: InputMaybe<Scalars['String']['input']>;
  returnOnEmptyQuery?: InputMaybe<Scalars['Boolean']['input']>;
  shopId?: InputMaybe<Scalars['ObjectId']['input']>;
};


export type QueryFindServiceLocationsArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
  returnOnEmptyQuery?: InputMaybe<Scalars['Boolean']['input']>;
  shopId?: InputMaybe<Scalars['ObjectId']['input']>;
};


export type QueryFindShopsArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
  returnOnEmptyQuery?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFirmwareVersionsArgs = {
  firmwareType: FirmwareTypeEnum;
  pagination?: PaginationInputObjectType;
  sort?: InputMaybe<FirmwareVersionSortInputObjectType>;
};


export type QueryGetAnnouncementByIdArgs = {
  id: Scalars['ObjectId']['input'];
};


export type QueryGetApiKeyByIdArgs = {
  id: Scalars['ObjectId']['input'];
};


export type QueryGetCustomerByIdArgs = {
  id: Scalars['ObjectId']['input'];
};


export type QueryGetDeviceLogByIdArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>;
};


export type QueryGetDispatchWoytiNotificationsCountArgs = {
  shopId: Scalars['ObjectId']['input'];
};


export type QueryGetLockerByIdArgs = {
  id: Scalars['ObjectId']['input'];
};


export type QueryGetLogItemByIdArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>;
};


export type QueryGetOrderByIdArgs = {
  id: Scalars['ObjectId']['input'];
};


export type QueryGetOrderByOrderTokenArgs = {
  orderToken: Scalars['String']['input'];
};


export type QueryGetOrderByShortTokenArgs = {
  shortToken: Scalars['String']['input'];
};


export type QueryGetOrderByTokenAndIdArgs = {
  id: Scalars['ObjectId']['input'];
  token: Scalars['String']['input'];
};


export type QueryGetOrganisationByIdArgs = {
  id: Scalars['ObjectId']['input'];
};


export type QueryGetOrganisationByWoytiPathnameArgs = {
  pathname?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetOrganisationWoytiShopsArgs = {
  pagination?: PaginationInputObjectType;
};


export type QueryGetOverwriteCodeByIdArgs = {
  id: Scalars['ObjectId']['input'];
};


export type QueryGetProductByIdArgs = {
  id: Scalars['ObjectId']['input'];
};


export type QueryGetQualityGuardSummaryArgs = {
  organisationId: Scalars['ObjectId']['input'];
};


export type QueryGetReservationByIdArgs = {
  id: Scalars['ObjectId']['input'];
};


export type QueryGetReservationByIdAndTokenArgs = {
  id: Scalars['ObjectId']['input'];
  token: Scalars['String']['input'];
};


export type QueryGetServiceLocationByIdArgs = {
  id: Scalars['ObjectId']['input'];
};


export type QueryGetShopByIdArgs = {
  id: Scalars['ObjectId']['input'];
};


export type QueryGetStableFirmwareVersionArgs = {
  firmwareType: FirmwareTypeEnum;
};


export type QueryGetUserByIdArgs = {
  id?: InputMaybe<Scalars['ObjectId']['input']>;
};


export type QueryGetWoytiFavoriteCountArgs = {
  shopId: Scalars['ObjectId']['input'];
};


export type QueryGetWoytiReservationsByShopIdArgs = {
  shopId: Scalars['ObjectId']['input'];
  shouldReturnSoldReservations?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetWoytiShopByIdArgs = {
  id: Scalars['ObjectId']['input'];
};


export type QueryGetWoytiShoppingCartArgs = {
  items: Array<Scalars['ObjectId']['input']>;
  shopId: Scalars['ObjectId']['input'];
};


export type QueryGetWoytiShopsArgs = {
  pagination?: PaginationInputObjectType;
  testmode?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLockerTemperatureSummaryArgs = {
  lockerId: Scalars['ObjectId']['input'];
  minEpisodeMinutes?: InputMaybe<Scalars['Int']['input']>;
  rangeEnd: Scalars['DateTime']['input'];
  rangeStart: Scalars['DateTime']['input'];
  thresholdCelsius?: InputMaybe<Scalars['Float']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLockerTemperaturesArgs = {
  createdAt?: InputMaybe<DateRangeInputObjectType>;
  lockerId: Scalars['ObjectId']['input'];
  pagination?: PaginationInputObjectType;
};


export type QueryLockersArgs = {
  pagination?: PaginationInputObjectType;
  shopId?: InputMaybe<Scalars['ObjectId']['input']>;
};


export type QueryLogsArgs = {
  filter?: InputMaybe<LogFilterInputObjectType>;
  pagination?: PaginationInputObjectType;
  sort?: InputMaybe<LogSortInputObjectType>;
};


export type QueryNotificationsArgs = {
  pagination?: PaginationInputObjectType;
};


export type QueryOrderSummaryArgs = {
  period?: OrderSummaryPeriodEnumType;
  shopId: Scalars['ObjectId']['input'];
};


export type QueryOrdersArgs = {
  filter?: InputMaybe<OrderFilterInputObjectType>;
  pagination?: PaginationInputObjectType;
  shopId?: InputMaybe<Scalars['ObjectId']['input']>;
  sort?: InputMaybe<OrderSortInputObjectType>;
};


export type QueryOrganisationUsersArgs = {
  pagination?: PaginationInputObjectType;
};


export type QueryOrganisationsArgs = {
  dealerId?: InputMaybe<Scalars['ObjectId']['input']>;
  pagination?: PaginationInputObjectType;
};


export type QueryOverwriteCodesArgs = {
  pagination?: PaginationInputObjectType;
  shopId?: InputMaybe<Scalars['ObjectId']['input']>;
};


export type QueryPrintHubClaimPreviewArgs = {
  claimToken: Scalars['String']['input'];
};


export type QueryPrintHubLayoutPreviewArgs = {
  input: PrintHubLayoutPreviewInputObjectType;
};


export type QueryPrintHubPrinterSuggestionsArgs = {
  font?: InputMaybe<PrintHubEscPosFontEnum>;
  paperWidthMm?: InputMaybe<Scalars['Int']['input']>;
  printerName: Scalars['String']['input'];
};


export type QueryProductsArgs = {
  pagination?: PaginationInputObjectType;
  sort?: InputMaybe<ProductSortInputObjectType>;
};


export type QueryQualityGuardRecipeArgs = {
  organisationId: Scalars['ObjectId']['input'];
  plu: Scalars['String']['input'];
};


export type QueryQuotaUsagesArgs = {
  organisationId: Scalars['ObjectId']['input'];
  types: Array<QuotaTypeEnumType>;
};


export type QueryResellerArgs = {
  id: Scalars['ObjectId']['input'];
};


export type QueryResellerUsersArgs = {
  pagination?: PaginationInputObjectType;
  resellerId: Scalars['ObjectId']['input'];
};


export type QueryResellersArgs = {
  pagination?: PaginationInputObjectType;
};


export type QueryReservationSettingsArgs = {
  organisationId: Scalars['ObjectId']['input'];
  shopId: Scalars['ObjectId']['input'];
};


export type QueryReservationsArgs = {
  filter?: InputMaybe<ReservationFilterInputObjectType>;
  pagination?: PaginationInputObjectType;
  shopId?: InputMaybe<Scalars['ObjectId']['input']>;
  sort?: InputMaybe<ReservationSortInputObjectType>;
};


export type QuerySearchAddressArgs = {
  countries?: InputMaybe<Array<CountryEnum>>;
  query: Scalars['String']['input'];
};


export type QueryServiceLocationsArgs = {
  pagination?: PaginationInputObjectType;
  shopId?: InputMaybe<Scalars['ObjectId']['input']>;
};


export type QueryShopPrintHubStatusArgs = {
  shopId: Scalars['ObjectId']['input'];
};


export type QueryShopsArgs = {
  pagination?: PaginationInputObjectType;
};


export type QueryUsageLedgerEntriesArgs = {
  organisationId: Scalars['ObjectId']['input'];
  pagination?: PaginationInputObjectType;
  type: QuotaTypeEnumType;
};


export type QueryWoocommerceIntegrationArgs = {
  organisationId: Scalars['ObjectId']['input'];
  shopId: Scalars['ObjectId']['input'];
};

/** A list of all possible Quota types */
export enum QuotaTypeEnumType {
  /** Quota is of type Customers */
  Customers = 'Customers',
  /** Quota is of type Emails */
  Emails = 'Emails',
  /** Quota is of type Products */
  Products = 'Products',
  /** Quota is of type Reservations */
  Reservations = 'Reservations',
  /** Quota is of type SMS */
  Sms = 'SMS',
  /** Quota is of type Uploads */
  Uploads = 'Uploads',
  /** Quota is of type Users */
  Users = 'Users'
}

/** Object that describes the current quota usage and limit */
export type QuotaUsageObjectType = {
  __typename?: 'QuotaUsageObjectType';
  _id: Scalars['ObjectId']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Datetime of last reset */
  lastResetAt?: Maybe<Scalars['DateTime']['output']>;
  /** Total limit of the quota (baseLimit * multiplier) */
  limit: Scalars['Float']['output'];
  /** Base limit, this gets multiplied by the multiplier to get the actual limit */
  limitBase: Scalars['Float']['output'];
  /** The multiplier that is used to calculate the total limit */
  multiplier: Scalars['Float']['output'];
  /** The type of multiplier that is used to calculate the total limit */
  multiplierType?: Maybe<Scalars['String']['output']>;
  /** id of the linked organisation */
  organisationId: Scalars['ObjectId']['output'];
  /** Datetime of next reset */
  resetsAt?: Maybe<Scalars['DateTime']['output']>;
  type: QuotaTypeEnumType;
  updatedAt: Scalars['DateTime']['output'];
  /** Used amount in the current quotas timespan */
  usage: Scalars['Float']['output'];
};

/** Information required to create or update a reseller. */
export type ResellerInputObjectType = {
  address: AddressInputObjectType;
  companyName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  phonenumber: Scalars['PhoneNumber']['input'];
  registrationNumber: Scalars['String']['input'];
  vatNumber: Scalars['String']['input'];
};

/** Information about a reseller. */
export type ResellerObjectType = {
  __typename?: 'ResellerObjectType';
  _id: Scalars['ObjectId']['output'];
  address: AddressObjectType;
  companyName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  /** External id used to identify a reseller, this id might get used for invoices and support */
  id: Scalars['Int']['output'];
  phonenumber: Scalars['PhoneNumber']['output'];
  registrationNumber: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vatNumber: Scalars['String']['output'];
};

/** Filters results to match these specified queries. */
export type ReservationFilterInputObjectType = {
  /** Filters reservations based on whether they are for vending purposes */
  isVendingReservation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters reservations to be within this date range */
  pickupDateTime?: InputMaybe<DateRangeInputObjectType>;
  /** Filters by reservation status(es) */
  status?: InputMaybe<Array<ReservationStatusEnumType>>;
};

/** Object that contains all information about a reservation */
export type ReservationObjectType = {
  __typename?: 'ReservationObjectType';
  /** An internal id used within the platform */
  _id: Scalars['ObjectId']['output'];
  autoHideVendingAfterHours?: Maybe<Scalars['Int']['output']>;
  /** If true and the reservation has reach the configured time before pickup, we will automatically send a notification. */
  automaticallySendNotification: Scalars['Boolean']['output'];
  /** The boxes this reservation occupies. */
  boxes: Array<BoxReservationObjectType>;
  /** Does this reservation contain food. */
  canUseMealVouchers?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** The customer this reservation belongs to. */
  customer?: Maybe<CustomerObjectType>;
  /** The internal id of the customer this reservation belongs to. */
  customerId?: Maybe<Scalars['ObjectId']['output']>;
  /** Optional note for the customer, included in reservation emails. Separate from extraInformation which stays internal. */
  customerNote?: Maybe<Scalars['String']['output']>;
  /** The email of the customer. */
  emails: Array<Scalars['String']['output']>;
  /** An optional external id to identify the order, mainly used for integrating with 3rd party platforms */
  externalOrderId?: Maybe<Scalars['String']['output']>;
  /** Information about the reservation, this is usually a description of the content. */
  extraInformation?: Maybe<Scalars['String']['output']>;
  /** The first name of the customer. */
  firstName: Scalars['String']['output'];
  /** A list of free vending product items */
  freeProducts: Array<ProductCollectionItemObjectType>;
  hideVending?: Maybe<Scalars['Boolean']['output']>;
  /** A sequential numeric id, mainly used for visual purposes */
  id: Scalars['Int']['output'];
  /** True if this pincode has not been generated but defined by a user */
  isCustomPincode: Scalars['Boolean']['output'];
  /** Is reservation a vending reservation */
  isVendingReservation: Scalars['Boolean']['output'];
  /** The amount of joyn points the customer will receive. */
  joynPoints?: Maybe<Scalars['Int']['output']>;
  language: LanguageEnum;
  /** The last name of the customer. */
  lastName: Scalars['String']['output'];
  /** If true and the reservation has been picked up this locker will remain reserved untill manually completed. */
  noAutoComplete: Scalars['Boolean']['output'];
  /** The notifications that should be dispatched x amount of time before pickup. */
  notificationTypes: Array<Maybe<NotificationTypeEnumType>>;
  /** Amount of times a notification has been sent, ideally this should be 1. */
  notificationsSent: Scalars['Int']['output'];
  /** The order orderId points to */
  order?: Maybe<OrderObjectType>;
  /** An optional id pointing to a linked order */
  orderId?: Maybe<Scalars['ObjectId']['output']>;
  /** The mobile phone number of the customer. */
  phonenumbers: Array<Scalars['PhoneNumber']['output']>;
  /** The time the reservation is planned for pickup */
  pickupDateTime: Scalars['DateTime']['output'];
  /** A 4-5 character numeric pincode used for opening the locker at pickup */
  pincode: Scalars['String']['output'];
  reservedAt?: Maybe<Scalars['DateTime']['output']>;
  sendNotificationAt?: Maybe<Scalars['DateTime']['output']>;
  shop?: Maybe<ShopObjectType>;
  shopId: Scalars['ObjectId']['output'];
  /** Should customer still pay this reservation, this will send a pay link to the customer when box gets reserved. */
  shouldCustomerPay?: Maybe<Scalars['Boolean']['output']>;
  /** Current status of the reservation */
  status: ReservationStatusEnumType;
  /** If true, this reservation does not have boxes assigned and has status CREATED. */
  unboxed?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** Last time the status has been updated */
  updatedStatusAt: Scalars['DateTime']['output'];
  /** Optional date until which the reservation is valid (houdbaar tot) in YYYY-MM-DD format */
  validUntil?: Maybe<Scalars['String']['output']>;
  /** A discount percentage to apply to the vending total price, ex 500 => 5% */
  vendingDiscount?: Maybe<Scalars['Int']['output']>;
  /** The vending discount intervals */
  vendingDiscountIntervals: Array<VendingDiscountIntervals>;
  /** A list of vending product items */
  vendingProducts: Array<ProductCollectionItemObjectType>;
  /** The total price of the reservation for vending purposes */
  vendingTotalPrice?: Maybe<Scalars['Int']['output']>;
};

export type ReservationPaginatedResultObjectType = {
  __typename?: 'ReservationPaginatedResultObjectType';
  /** The amount of items in the response */
  count: Scalars['Int']['output'];
  /** Documents */
  docs: Array<ReservationObjectType>;
  /** The defined limit value */
  limit: Scalars['Int']['output'];
  /** The defined skip value */
  skip: Scalars['Int']['output'];
  /** The total amount of documents that match your query */
  total: Scalars['Int']['output'];
};

/** Object that describes the reservation settings input */
export type ReservationSettingsInputObjectType = {
  organisationId: Scalars['ObjectId']['input'];
  /** If this is true, a box will be selected by default */
  selectDefaultBox: Scalars['Boolean']['input'];
  shopId: Scalars['ObjectId']['input'];
  /** If this is true a customer should pay by default */
  shouldCustomerPay: Scalars['Boolean']['input'];
};

/** Object that describes the current quota usage and limit */
export type ReservationSettingsObjectType = {
  __typename?: 'ReservationSettingsObjectType';
  _id: Scalars['String']['output'];
  organisationId: Scalars['ObjectId']['output'];
  /** If this is true, a box will be selected by default */
  selectDefaultBox: Scalars['Boolean']['output'];
  shopId: Scalars['ObjectId']['output'];
  /** If this is true a customer should pay by default */
  shouldCustomerPay: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Sort the results based on the value of this object */
export type ReservationSortInputObjectType = {
  /** Sort based on the value: _id */
  _id?: InputMaybe<SortEnumType>;
  /** Sort based on the value: customerId */
  customerId?: InputMaybe<SortEnumType>;
  /** Sort based on the value: externalOrderId */
  externalOrderId?: InputMaybe<SortEnumType>;
  /** Sort based on the value: id */
  id?: InputMaybe<SortEnumType>;
  /** Sort based on the value: noAutoComplete */
  noAutoComplete?: InputMaybe<SortEnumType>;
  /** Sort based on the value: notificationTypes */
  notificationTypes?: InputMaybe<SortEnumType>;
  /** Sort based on the value: orderId */
  orderId?: InputMaybe<SortEnumType>;
  /** Sort based on the value: pickupDateTime */
  pickupDateTime?: InputMaybe<SortEnumType>;
  /** Sort based on the value: pincode */
  pincode?: InputMaybe<SortEnumType>;
  /** Sort based on the value: status */
  status?: InputMaybe<SortEnumType>;
};

/** The current status of the reservation */
export enum ReservationStatusEnumType {
  /** Reservation has been cancelled */
  Cancelled = 'cancelled',
  /** Reservation has been picked up */
  Completed = 'completed',
  /** Reservation has been created */
  Created = 'created',
  /**
   * Reservation has been ordered in the vending machine, not neccessarily paid. If
   * order gets cancelled or expires it will return to reserved.
   */
  Ordered = 'ordered',
  /** A box in the locker has been reserved */
  Reserved = 'reserved',
  /** Reservation ready notifications have been sent */
  Sent = 'sent'
}

/** The state of the gateway linked to the service location */
export type ServiceLocationDeviceStateObjectType = {
  __typename?: 'ServiceLocationDeviceStateObjectType';
  /** Config version of the gateway */
  configVersion: Scalars['Int']['output'];
  /** Connection status online/offline */
  connectionStatus: ConnectionStatusEnum;
  /** Firmware versions of the gateway */
  firmwareVersions: DeviceFirmwareVersionsObjectType;
  /** Last time we received an MQTT error */
  lastErrorAt?: Maybe<Scalars['DateTime']['output']>;
  /** Last error message we received */
  lastErrorMessage?: Maybe<Scalars['String']['output']>;
  /** Last time the device was offline */
  lastOfflineAt?: Maybe<Scalars['DateTime']['output']>;
  /** Last time we received a heartbeat */
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  /** Last time we received a state update */
  lastStateUpdate?: Maybe<Scalars['DateTime']['output']>;
};

export type ServiceLocationFilterInputObjectType = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  isBetaTester?: InputMaybe<Scalars['Boolean']['input']>;
  isOnline?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Object used for creating/updating a new service location */
export type ServiceLocationInputObjectType = {
  /** The MQTT password used by this gateway */
  MQTTPassword: Scalars['String']['input'];
  /** Start date of the billing cycle, devices are not allowed to use any data before this date */
  billingStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Device id of the gateway */
  deviceId: Scalars['String']['input'];
  /** iccid of the sim card */
  iccid: Scalars['String']['input'];
  /** Should this device receive the newest Beta firmware? If this is false, it defaults to the stable release channel. */
  isBetaTester: Scalars['Boolean']['input'];
  /** Serial number of the router */
  routerSerial: Scalars['String']['input'];
  /** Shop ID, points to the shop this service location belongs to */
  shopId: Scalars['ObjectId']['input'];
};

/** Service location is just a gateway but we messed up naming at the start */
export type ServiceLocationObjectType = {
  __typename?: 'ServiceLocationObjectType';
  MQTTPassword?: Maybe<Scalars['String']['output']>;
  /** Internal id used for linking to other objects and getting this object */
  _id: Scalars['ObjectId']['output'];
  /** Start date of the billing cycle, devices are not allowed to use any data before this date */
  billingStartDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Device id of the gateway */
  deviceId: Scalars['String']['output'];
  /** State of the device/gateway */
  deviceState: ServiceLocationDeviceStateObjectType;
  iccid: Scalars['String']['output'];
  /** A flag to indicate that this is a test-device used for testing new firmware */
  isBetaTester: Scalars['Boolean']['output'];
  /** All lockers that are part of this service location */
  lockers: Array<LockerObjectType>;
  organisation?: Maybe<OrganisationObjectType>;
  /** Organisation ID, points to the organisation this service location belongs to */
  organisationId: Scalars['ObjectId']['output'];
  /** Amount of MQTT messages that are queued for this gateway */
  queuedMessagesCount: Scalars['Int']['output'];
  routerSerial: Scalars['String']['output'];
  /** Shop */
  shop?: Maybe<ShopObjectType>;
  /** Shop ID, points to the shop this service location belongs to */
  shopId: Scalars['ObjectId']['output'];
  simCard?: Maybe<SimCardDeviceObjectType>;
  teltonikaDevice?: Maybe<TeltonikaDeviceObjectType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ServiceLocationPaginatedResultObjectType = {
  __typename?: 'ServiceLocationPaginatedResultObjectType';
  /** The amount of items in the response */
  count: Scalars['Int']['output'];
  /** Documents */
  docs: Array<ServiceLocationObjectType>;
  /** The defined limit value */
  limit: Scalars['Int']['output'];
  /** The defined skip value */
  skip: Scalars['Int']['output'];
  /** The total amount of documents that match your query */
  total: Scalars['Int']['output'];
};

/** Object used for updating many service locations */
export type ServiceLocationUpdateManyInputObjectType = {
  /** Should this device receive the newest Beta firmware? If this is false, it defaults to the stable release channel. */
  isBetaTester: Scalars['Boolean']['input'];
};

/** Severity/importance of a notification */
export enum SeverityEnumType {
  Danger = 'danger',
  Info = 'info',
  Success = 'success',
  Warning = 'warning'
}

/** Object used for creating/updating a shop */
export type ShopInputObjectType = {
  /** The location of the service location by address */
  address: AddressInputObjectType;
  /** Default value to pre-fill when creating a vending reservation */
  defaultAutoHideVendingAfterHours?: InputMaybe<Scalars['Int']['input']>;
  /** Email that gets used for supporting your customers */
  email: Scalars['String']['input'];
  /** Extra note that gets appended to each mail */
  emailNote?: InputMaybe<Scalars['String']['input']>;
  /** If this is true, the shop will not be shown in the overview page of the virtual vending machine */
  hideVirtualVendingInOverview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the service location */
  name: Scalars['String']['input'];
  /** Opening hours description (free text) */
  openingHours?: InputMaybe<Scalars['String']['input']>;
  /** Phone number that gets used for supporting your customers */
  phonenumber: Scalars['PhoneNumber']['input'];
  /** Amount of minutes before the pickup date/time that the notification should be sent */
  timeBeforeConfirmationDispatch: Scalars['Int']['input'];
  /** The amount of hours a customer has to pickup an order when ordering from the vending machine */
  vendingPickupTime?: InputMaybe<Scalars['Int']['input']>;
  /** url to the webshop of this shop */
  webshopUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Shop */
export type ShopObjectType = {
  __typename?: 'ShopObjectType';
  /** Internal id used for linking to other objects and getting this object */
  _id: Scalars['ObjectId']['output'];
  /** The location of the service location by address */
  address: AddressObjectType;
  createdAt: Scalars['DateTime']['output'];
  defaultAutoHideVendingAfterHours: Scalars['Int']['output'];
  /** Email that gets used for supporting your customers */
  email: Scalars['String']['output'];
  /** Extra note that gets appended to each email to a customer */
  emailNote?: Maybe<Scalars['String']['output']>;
  /** If this is true, the shop will not be shown in the virtual vending overview page */
  hideVirtualVendingInOverview: Scalars['Boolean']['output'];
  /** Name of the service location */
  name: Scalars['String']['output'];
  /** Opening hours description (free text) */
  openingHours?: Maybe<Scalars['String']['output']>;
  /** Organisation this shop belongs to */
  organisation: OrganisationObjectType;
  /** Internal id used for linking to the organisation */
  organisationId: Scalars['ObjectId']['output'];
  /** Phone number that gets used for supporting your customers */
  phonenumber: Scalars['PhoneNumber']['output'];
  /** Amount of minutes before the pickup date/time that the notification should be sent */
  timeBeforeConfirmationDispatch: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** The amount of hours a customer has to pickup an order when ordering from the vending machine */
  vendingPickupTime: Scalars['Int']['output'];
  /**
   * Amount of vending reservations currently available for this shop
   * @deprecated use WoytiShopObjectType instead
   */
  vendingReservationsCount: Scalars['Int']['output'];
  /** url to the webshop of this shop */
  webshopUrl: Scalars['String']['output'];
};

export type ShopPaginatedResultObjectType = {
  __typename?: 'ShopPaginatedResultObjectType';
  /** The amount of items in the response */
  count: Scalars['Int']['output'];
  /** Documents */
  docs: Array<ShopObjectType>;
  /** The defined limit value */
  limit: Scalars['Int']['output'];
  /** The defined skip value */
  skip: Scalars['Int']['output'];
  /** The total amount of documents that match your query */
  total: Scalars['Int']['output'];
};

export type ShopPrintHubStatusObjectType = {
  __typename?: 'ShopPrintHubStatusObjectType';
  claim?: Maybe<PrintHubClaimObjectType>;
  configured: Scalars['Boolean']['output'];
  /** Failed print jobs in the last 24 hours */
  failedCount: Scalars['Int']['output'];
  hubId?: Maybe<Scalars['ObjectId']['output']>;
  hubName?: Maybe<Scalars['String']['output']>;
  /** Queued or started print jobs that are not finished yet */
  incompleteCount: Scalars['Int']['output'];
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  online: Scalars['Boolean']['output'];
  printerName?: Maybe<Scalars['String']['output']>;
  /** Average created→completed delay for recent prints (ms), if any */
  recentAvgDelayMs?: Maybe<Scalars['Int']['output']>;
  /** Number of completed prints used for the recent delay average */
  recentCompletedCount: Scalars['Int']['output'];
  settings?: Maybe<PrintHubSettingsObjectType>;
  trayUpdateRequired: Scalars['Boolean']['output'];
};

/** Sim card data */
export type SimCardDeviceObjectType = {
  __typename?: 'SimCardDeviceObjectType';
  /** Internal id used for linking to other objects and getting this object */
  _id: Scalars['ObjectId']['output'];
  createdAt: Scalars['DateTime']['output'];
  iccid: Scalars['String']['output'];
  imei: Scalars['String']['output'];
  imsi: Scalars['String']['output'];
  label: Scalars['String']['output'];
  subscription_description: Scalars['String']['output'];
  subscription_state: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Sort direction */
export enum SortEnumType {
  Asc = 'asc',
  Desc = 'desc'
}

/** Stripe Connect status for an organisation. */
export type StripeConnectStatusObjectType = {
  __typename?: 'StripeConnectStatusObjectType';
  _id: Scalars['ObjectId']['output'];
  canReceivePayments: Scalars['Boolean']['output'];
  lastStatusCheckAt?: Maybe<Scalars['DateTime']['output']>;
  livemode: Scalars['Boolean']['output'];
  organisationId: Scalars['ObjectId']['output'];
  stripeAccountEmail?: Maybe<Scalars['String']['output']>;
  stripeAccountId?: Maybe<Scalars['String']['output']>;
  stripeBusinessName?: Maybe<Scalars['String']['output']>;
};

/** Teltonika device */
export type TeltonikaDeviceObjectType = {
  __typename?: 'TeltonikaDeviceObjectType';
  /** Internal id used for linking to other objects and getting this object */
  _id: Scalars['ObjectId']['output'];
  /** Connection status online/offline */
  connection_status: ConnectionStatusEnum;
  /** teltonika device connection_type */
  connection_type: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** teltonika device description */
  description: Scalars['String']['output'];
  /** teltonika device firmware version */
  firmware: Scalars['String']['output'];
  /** teltonika device iccid */
  iccid: Scalars['String']['output'];
  /** teltonika internal id */
  id: Scalars['Int']['output'];
  /** teltonika device imei */
  imei: Scalars['String']['output'];
  /** teltonika device imsi */
  imsi: Scalars['String']['output'];
  /** teltonika device monitoring_enabled */
  is_monitoring_enabled: Scalars['Boolean']['output'];
  /** teltonika device connection_uptime in seconds */
  last_connection_uptime: Scalars['Int']['output'];
  /** teltonika device mac */
  mac: Scalars['String']['output'];
  /** teltonika model */
  model: Scalars['String']['output'];
  /** teltonika device name */
  name: Scalars['String']['output'];
  /** teltonika device serial */
  serial: Scalars['String']['output'];
  /** teltonika device sim_state */
  sim_state: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** teltonika device wlan_mac */
  wlan_mac: Scalars['String']['output'];
};

/** A list of all possible unit types */
export enum UnitEnumType {
  /** Product/Price is per kilogram */
  Kg = 'kg',
  /** Product/Price is per liter */
  Liter = 'liter',
  /** Product is expressed in amount */
  Unit = 'unit'
}

/** Data for updating an existing customer. */
export type UpdateCustomerInputObjectType = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * External id used for linking an internal customer to an external datasource,
   * usually this is the e-commerce or ERP system used by the company.
   */
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<LanguageEnum>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phonenumbers?: InputMaybe<Array<Scalars['PhoneNumber']['input']>>;
  /** A dedicated 5 character numeric pincode for the customer, so they can always pickup their order using the same pincode. */
  pincode?: InputMaybe<Scalars['String']['input']>;
};

/** Data that can be updated on the locker */
export type UpdateLockerInputObjectType = {
  boxCount?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  temperatureType?: InputMaybe<LockerTemperatureTypeEnum>;
};

/** Object describing an order. */
export type UpdateOrderInputObjectType = {
  /** Customer this order is linked to. */
  customerId?: InputMaybe<Scalars['ObjectId']['input']>;
  /** E-Mail of the customer */
  emails: Array<Scalars['String']['input']>;
  /** First Name of the customer */
  firstName: Scalars['String']['input'];
  /** Preferred language of the customer */
  language: LanguageEnum;
  /** Last Name of the customer */
  lastName: Scalars['String']['input'];
};

/** Reservation data that can be updated. */
export type UpdateReservationInputObjectType = {
  autoHideVendingAfterHours?: InputMaybe<Scalars['Int']['input']>;
  /** If true and the reservation has reach the configured time before pickup, we will automatically send a notification. */
  automaticallySendNotification?: Scalars['Boolean']['input'];
  /** Does this reservation contain food. */
  canUseMealVouchers?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The internal id of the customer this reservation belongs to. If none is
   * provided, contact information is required and we will automatically try to
   * link a customer using this information or create one if there is none.
   */
  customerId?: InputMaybe<Scalars['ObjectId']['input']>;
  /** The emails of the customer, defaults to the customer email if a customer id is provided. */
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  /** An optional external id to identify the order, mainly used for integrating with 3rd party platforms */
  externalOrderId?: InputMaybe<Scalars['String']['input']>;
  /** Information about the reservation, this is usually a description of the content. */
  extraInformation?: InputMaybe<Scalars['String']['input']>;
  /** The first name of the customer, defaults to the customer first name if a customer id is provided. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** A list of free vending product items */
  freeProducts?: Array<ProductCollectionItemInputObjectType>;
  /** Is reservation a vending reservation */
  isVendingReservation?: InputMaybe<Scalars['Boolean']['input']>;
  /** The preferred language of the customer */
  language?: LanguageEnum;
  /** The last name of the customer, defaults to the customer last name if a customer id is provided. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** If true and the reservation has been picked up this locker will remain reserved untill manually completed. */
  noAutoComplete?: Scalars['Boolean']['input'];
  /** The notifications that should be dispatched x amount of time before pickup. */
  notificationTypes?: Array<InputMaybe<NotificationTypeEnumType>>;
  /** An optional id pointing to a linked order */
  orderId?: InputMaybe<Scalars['ObjectId']['input']>;
  /** The phonenumbers of the customer, defaults to the customer phonenumber if a customer id is provided. */
  phonenumbers?: InputMaybe<Array<Scalars['PhoneNumber']['input']>>;
  /** The time the reservation is planned for pickup */
  pickupDateTime: Scalars['DateTime']['input'];
  /** A 4 character numeric pincode used for opening the locker at pickup */
  pincode?: InputMaybe<Scalars['String']['input']>;
  /** Should customer still pay this reservation, this will send a pay link to the customer when box gets reserved. */
  shouldCustomerPay?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, this reservation will not have boxes assigned and will immediately have status RESERVED. */
  unboxed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional date until which the reservation is valid (houdbaar tot) in YYYY-MM-DD format */
  validUntil?: InputMaybe<Scalars['String']['input']>;
  /** A discount percentage to apply to the vending total price, ex 500 => 5% */
  vendingDiscount?: InputMaybe<Scalars['Int']['input']>;
  /** The vending discount intervals */
  vendingDiscountIntervals?: InputMaybe<Array<UpdatevendingDiscountIntervalsInput>>;
  /** A list of vending product items */
  vendingProducts?: Array<ProductCollectionItemInputObjectType>;
  /** The total price of the reservation for vending purposes */
  vendingTotalPrice?: InputMaybe<Scalars['Int']['input']>;
};

/** Values used to update reservation status. */
export type UpdateReservationStatusInputObjectType = {
  /** Optional list of boxes, required when changing from created to reserved */
  boxes?: InputMaybe<Array<BoxReservationInputObjectType>>;
  /** Optional note for the customer, included in reservation emails when the box is reserved. Separate from extraInformation. */
  customerNote?: InputMaybe<Scalars['String']['input']>;
  /** The amount of joyn points the customer will receive. */
  joynPoints?: InputMaybe<Scalars['Int']['input']>;
  /** The amount that has to be paid before receiving pincode. */
  orderAmount?: InputMaybe<Scalars['Int']['input']>;
  /** The new status for the reservation */
  status: ReservationStatusEnumType;
};

export type UpdatevendingDiscountIntervalsInput = {
  /** The discount percentage */
  discount: Scalars['Int']['input'];
  /** The hours after creation the discount should be applied */
  hoursAfterCreation: Scalars['Int']['input'];
};

/** A token with all the data required to upload a file to our storage bucket */
export type UploadRequestTokenObjectType = {
  __typename?: 'UploadRequestTokenObjectType';
  bucket: Scalars['String']['output'];
  bucketUrl: Scalars['String']['output'];
  googAlgorithm: Scalars['String']['output'];
  googCredential: Scalars['String']['output'];
  googDate: Scalars['String']['output'];
  googSignature: Scalars['String']['output'];
  key: Scalars['String']['output'];
  policy: Scalars['String']['output'];
};

/** Object that describes the current quota usage and limit */
export type UsageLedgerEntryObjectType = {
  __typename?: 'UsageLedgerEntryObjectType';
  _id: Scalars['ObjectId']['output'];
  /** Used amount by the current log entry */
  amount: Scalars['Float']['output'];
  /** Api Key that created this log */
  apiKeyId?: Maybe<Scalars['ObjectId']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Describes this log entry */
  description: Scalars['String']['output'];
  /** Date and time when this log gets removed */
  removeAt?: Maybe<Scalars['DateTime']['output']>;
  type: QuotaTypeEnumType;
  updatedAt: Scalars['DateTime']['output'];
  /** Total usage when this log was created */
  usage: Scalars['Float']['output'];
  /** User that created the log */
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserObjectType = {
  __typename?: 'UserObjectType';
  _id: Scalars['ObjectId']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  highestRole?: Maybe<UserRoleObjectType>;
  isPasswordLoginEnabled: Scalars['Boolean']['output'];
  language: LanguageEnum;
  lastReadAnnouncementAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  roles?: Maybe<Array<Maybe<UserRoleObjectType>>>;
  /** @deprecated Deprecated in favor of _id */
  uid: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type UserPaginatedResultObjectType = {
  __typename?: 'UserPaginatedResultObjectType';
  /** The amount of items in the response */
  count: Scalars['Int']['output'];
  /** Documents */
  docs: Array<UserObjectType>;
  /** The defined limit value */
  limit: Scalars['Int']['output'];
  /** The defined skip value */
  skip: Scalars['Int']['output'];
  /** The total amount of documents that match your query */
  total: Scalars['Int']['output'];
};

export type UserPreferencesInputObjectType = {
  isPasswordLoginEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<LanguageEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UserRoleObjectType = {
  __typename?: 'UserRoleObjectType';
  _id: Scalars['ObjectId']['output'];
  organisation?: Maybe<OrganisationObjectType>;
  referenceId?: Maybe<Scalars['ObjectId']['output']>;
  referenceType?: Maybe<UserRoleReferenceTypeEnum>;
  role: Scalars['Int']['output'];
  userId: Scalars['ObjectId']['output'];
};

/** An enum that the type of reference in a user role */
export enum UserRoleReferenceTypeEnum {
  /** A dealer of the viresmo platform */
  Dealer = 'Dealer',
  /** An organisation/customer of the viresmo platform */
  Organisation = 'Organisation',
  /** A reseller of the viresmo platform */
  Reseller = 'Reseller'
}

export type VendingDiscountIntervals = {
  __typename?: 'VendingDiscountIntervals';
  /** The discount percentage */
  discount: Scalars['Int']['output'];
  /** The hours after creation the discount should be applied */
  hoursAfterCreation: Scalars['Int']['output'];
};

/** WooCommerce integration details. */
export type WooCommerceIntegrationObjectType = {
  __typename?: 'WooCommerceIntegrationObjectType';
  /** An internal id used within the platform */
  _id: Scalars['ObjectId']['output'];
  apiKey: Scalars['String']['output'];
  apiSecret: Scalars['String']['output'];
  apiUrl: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  shopId: Scalars['ObjectId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Information about an organisation. */
export type WoytiOrganisationObjectType = {
  __typename?: 'WoytiOrganisationObjectType';
  _id: Scalars['ObjectId']['output'];
  address: AddressObjectType;
  brandColor: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  /** External id used to identify viresmo organisations, this id gets put on invoices */
  id: Scalars['Int']['output'];
  /** Kiosk Bancontact/Payconiq QR shortcut preference. Default follows the code default (currently QR). */
  kioskPaymentQrMode: KioskPaymentQrModeEnumType;
  language: LanguageEnum;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pathname: Scalars['String']['output'];
  phonenumber: Scalars['PhoneNumber']['output'];
  registrationNumber: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vatNumber: Scalars['String']['output'];
};

export type WoytiPreferences = {
  __typename?: 'WoytiPreferences';
  _id: Scalars['ObjectId']['output'];
  clientId: Scalars['String']['output'];
  favoriteShops: Array<Scalars['ObjectId']['output']>;
  lastNotificationAt?: Maybe<Scalars['DateTime']['output']>;
  locale: Scalars['String']['output'];
  notificationToken?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type WoytiPreferencesInput = {
  clientId: Scalars['String']['input'];
  favoriteShops: Array<Scalars['ObjectId']['input']>;
  locale: Scalars['String']['input'];
  notificationToken?: InputMaybe<Scalars['String']['input']>;
};

export type WoytiReservationObjectType = {
  __typename?: 'WoytiReservationObjectType';
  /** An internal id used within the platform */
  _id: Scalars['ObjectId']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** A list of free vending product items */
  freeProducts: Array<ProductCollectionItemObjectType>;
  /** A sequential numeric id, mainly used for visual purposes */
  id: Scalars['Int']['output'];
  /** Is reservation a vending reservation */
  isVendingReservation: Scalars['Boolean']['output'];
  shop?: Maybe<WoytiShopObjectType>;
  shopId: Scalars['ObjectId']['output'];
  /** Current status of the reservation */
  status: ReservationStatusEnumType;
  /** If true, this reservation does not have boxes assigned and has status CREATED. */
  unboxed?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** Last time the status has been updated */
  updatedStatusAt: Scalars['DateTime']['output'];
  /** Optional date until which the reservation is valid (houdbaar tot) in YYYY-MM-DD format */
  validUntil?: Maybe<Scalars['String']['output']>;
  /** A discount percentage to apply to the vending total price, ex 500 => 5% */
  vendingDiscount?: Maybe<Scalars['Int']['output']>;
  /** A list of vending product items */
  vendingProducts: Array<ProductCollectionItemObjectType>;
  /** The total price of the reservation for vending purposes */
  vendingTotalPrice?: Maybe<Scalars['Int']['output']>;
};

/** Woyti Shop */
export type WoytiShopObjectType = {
  __typename?: 'WoytiShopObjectType';
  /** Internal id used for linking to other objects and getting this object */
  _id: Scalars['ObjectId']['output'];
  /** The location of the service location by address */
  address: AddressObjectType;
  createdAt: Scalars['DateTime']['output'];
  /** Email that gets used for supporting your customers */
  email: Scalars['String']['output'];
  /** If this is true, the shop will not be shown in the virtual vending overview page */
  hideVirtualVendingInOverview: Scalars['Boolean']['output'];
  /** Name of the service location */
  name: Scalars['String']['output'];
  /** Opening hours description (free text) */
  openingHours?: Maybe<Scalars['String']['output']>;
  /** Organisation this shop belongs to */
  organisation: WoytiOrganisationObjectType;
  /** Internal id used for linking to the organisation */
  organisationId: Scalars['ObjectId']['output'];
  /** Phone number that gets used for supporting your customers */
  phonenumber: Scalars['PhoneNumber']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** The amount of hours a customer has to pickup an order when ordering from the vending machine */
  vendingPickupTime: Scalars['Int']['output'];
  /** url to the webshop of this shop */
  webshopUrl: Scalars['String']['output'];
  /** Amount of vending reservations currently available for this shop */
  woytiReservationsCount: Scalars['Int']['output'];
};

export type WoytiShopPaginatedResultObjectType = {
  __typename?: 'WoytiShopPaginatedResultObjectType';
  /** The amount of items in the response */
  count: Scalars['Int']['output'];
  /** Documents */
  docs: Array<WoytiShopObjectType>;
  /** The defined limit value */
  limit: Scalars['Int']['output'];
  /** The defined skip value */
  skip: Scalars['Int']['output'];
  /** The total amount of documents that match your query */
  total: Scalars['Int']['output'];
};
